<template>
    <div class="content">
        <el-row :gutter="20">
            <el-col :span="19">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span class="text">一、当事人基本信息</span>
                        <p>{{bz}}</p>
                        <!-- <el-button type="warning" size="small" @click="getBack">返回</el-button> -->
                        <el-button type="warning" size="small" @click="getTb" style="margin:5px 10px 0 0;">基本信息同步</el-button>
                    </div>
                    <div class="box-cont">
                        <el-form :model="form1" ref="form1" label-width="100px">
                            <template v-if="form1.jingyingzhe=='个人'||form1.jingyingzhe=='公民'">
                                <el-row>
                                    <el-col :span="6">
                                        <el-form-item label="法人类别:" prop="jingyingzhe" >
                                            <el-select v-model="form1.jingyingzhe" clearable placeholder="请选择" size="small">
                                                <el-option 
                                                    v-for="dict in jingyingzheOptions"
                                                    :key="dict.id"
                                                    :label="dict.jingyingzhe"
                                                    :value="dict.jingyingzhe"
                                                    ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                            <el-col :span="6">
                                <!-- disabled -->
                                <el-form-item label="个人:" prop="jingyingzhexm">
                                    <el-input
                                    v-model="form1.jingyingzhexm"
                                    placeholder="请输入个人"
                                    clearable
                                    size="small"
                                    
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="6">
                            <el-form-item label="性别:" prop="frxb">
                                <!-- :disabled="dwForm.frxb?true:false" -->
                                <el-select v-model="form1.frxb" placeholder="" size="small">
                                    <el-option 
                                        v-for="dict in xbOptions"
                                        :key="dict.id"
                                        :label="dict.label"
                                        :value="dict.label"
                                        ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                            <el-col :span="6">
                                    <el-form-item label="民族:" prop="nation">
                                        <!-- :disabled="dwForm.nation?true:false" -->
                                <el-select v-model="form1.nation" placeholder="请选择民族" size="small">
                                    <el-option
                                        v-for="dict in mzOptions"
                                        :key="dict.id"
                                        :label="dict.nation"
                                        :value="dict.xh"
                                        ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="10">
                            <el-form-item label="住址:" prop="zhuzhi">
                                <!-- :disabled="dwForm.dwdz?true:false" -->
                                <el-input
                                v-model="form1.zhuzhi"
                                placeholder="请输入住址"
                                clearable
                                size="small"
                                
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                        <el-form-item label="联系电话:" prop="sj1">
                            <!-- :disabled="dwForm.sj1?true:false" -->
                                <el-input 
                                v-model="form1.sj1"
                                placeholder="请输入联系电话"
                                clearable
                                size="small"
                                />
                            </el-form-item>  
                        </el-col> 
                        <el-col :span="8">
                            <el-form-item label="身份证号:" prop="sfzh">
                                <!-- :disabled="dwForm.sfzh?true:false" -->
                                <el-input
                                v-model="form1.sfzh"
                                placeholder="请输入身份证号"
                                clearable
                                size="small"
                                
                                />
                            </el-form-item>
                        </el-col>
                        
                            <el-col :span="10">
                            <el-form-item label="地址:" prop="dwdz">
                                <!-- :disabled="dwForm.dwdz?true:false" -->
                                <el-input
                                v-model="form1.dwdz"
                                placeholder="请输入地址"
                                clearable
                                size="small"
                                
                                />
                            </el-form-item>
                        </el-col>
                            </el-row>
                            </template>
                            <template v-else>
                            <el-row>
                            <el-col :span="12">
                                <!-- disabled -->
                                <el-form-item label="当事人:" prop="dwmc">
                                    <el-input
                                    v-model="form1.dwmc"
                                    placeholder="请输入当事人"
                                    clearable
                                    size="small"
                                    
                                    />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                            <el-form-item label="地址:" prop="dwdz">
                                <!-- :disabled="dwForm.dwdz?true:false" -->
                                <el-input
                                v-model="form1.dwdz"
                                placeholder="请输入地址"
                                clearable
                                size="small"
                                
                                />
                            </el-form-item>
                        </el-col>
                            <el-col :span="12">
                            <el-form-item :label="xkzText" prop="xkzh" :label-width="dwForm.zylbId == '06'?'160px':'140px'">
                                <!-- :disabled="dwForm.xkzh?true:false" -->
                                <el-input
                                v-model="form1.xkzh"
                                placeholder="请输入卫生许可证号"
                                clearable
                                size="small"
                                
                                />
                            </el-form-item>
                        </el-col>
                            <el-col :span="12">
                            <el-form-item label="统一社会信用代码:" prop="zzdm" label-width="140px">
                                <!-- :disabled="dwForm.zzdm?true:false" -->
                                <el-input 
                                v-model="form1.zzdm"
                                placeholder="请输入统一社会信用代码"
                                clearable
                                size="small"
                                
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="法人类别:" prop="jingyingzhe" >
                                <el-select v-model="form1.jingyingzhe" clearable placeholder="请选择" size="small">
                                    <el-option 
                                        v-for="dict in jingyingzheOptions"
                                        :key="dict.id"
                                        :label="dict.jingyingzhe"
                                        :value="dict.jingyingzhe"
                                        ></el-option>
                                </el-select>
                            </el-form-item>
                            </el-col>
                            <el-col :span="7">
                            <el-form-item :label="form1.jingyingzhe?form1.jingyingzhe+':':'负责人:'" prop="fzr"  label-width="120px">
                                <!-- :disabled="dwForm.fzr?true:false" -->
                                <el-input 
                                v-model="form1.jingyingzhexm"
                                placeholder="请输入"
                                clearable
                                size="small"
                                />
                            </el-form-item>
                            </el-col>
                            <el-col :span="3">
                            <el-form-item label="性别:" prop="frxb" label-width="55px">
                                <!-- :disabled="dwForm.frxb?true:false" -->
                                <el-select v-model="form1.frxb" placeholder="" size="small">
                                    <el-option 
                                        v-for="dict in xbOptions"
                                        :key="dict.id"
                                        :label="dict.label"
                                        :value="dict.label"
                                        ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                            <el-col :span="4">
                                    <el-form-item label="民族:" prop="nation" label-width="55px">
                                        <!-- :disabled="dwForm.nation?true:false" -->
                                <el-select v-model="form1.nation" placeholder="请选择民族" size="small">
                                    <el-option
                                        v-for="dict in mzOptions"
                                        :key="dict.id"
                                        :label="dict.nation"
                                        :value="dict.xh"
                                        ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                            <el-col :span="4">
                            <el-form-item label="职务:" prop="frzw" label-width="55px">
                                <!-- :disabled="dwForm.frzw?true:false" -->
                                <el-select v-model="form1.frzw"  placeholder="请选择职务" size="small">
                                    <el-option
                                        v-for="dict in zwOptions"
                                        :key="dict.px"
                                        :label="dict.zw"
                                        :value="dict.zw"
                                        ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                            <el-col :span="9">
                            <el-form-item label="身份证号:" prop="sfzh">
                                <!-- :disabled="dwForm.sfzh?true:false" -->
                                <el-input
                                v-model="form1.sfzh"
                                placeholder="请输入身份证号"
                                clearable
                                size="small"
                                
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="7">
                        <el-form-item label="联系电话:" prop="sj1">
                            <!-- :disabled="dwForm.sj1?true:false" -->
                                <el-input 
                                v-model="form1.sj1"
                                placeholder="请输入联系电话"
                                clearable
                                size="small"
                                />
                            </el-form-item>  
                        </el-col> 
                            <!-- <el-col :span="8" v-if="isNew == 2">
                            <el-form-item>
                                <el-button type="primary" size="small" @click="handleAdd">变更当事人基本信息</el-button>
                            </el-form-item>
                            </el-col> -->
                            </el-row>
                            </template>
                            
                        </el-form>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span class="text">二、案件基本信息</span>
                        <el-button v-if="isNew == 2" type="warning" size="small" @click="getTb2" style="margin:5px 10px 0 0;">案件信息同步</el-button>
                    </div>
                    <div class="box-cont">
                        <el-form :model="form2" ref="queryForm2" label-width="100px">
                            <el-row>
                                <el-col :span="8">
                            <el-form-item label="案件来源:" prop="laiyuan">
                                <el-select v-model="form2.laiyuan" placeholder="请选择案件来源" size="small" @change="changeXcbl">
                                    <el-option
                                        v-for="dict in lyOptions"
                                        :key="dict.id"
                                        :label="dict.ajly"
                                        :value="dict.ajly"
                                        ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                            <!-- <el-col :span="12">
                            <el-form-item label="立案审批文号:" prop="lianWenhao">
                                <el-input
                                v-model="form2.lianWenhao"
                                placeholder="请输入立案审批文号"
                                clearable
                                size="small"
                                
                                />
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="8" v-if="this.form2.laiyuan && this.form2.laiyuan.indexOf('检验') != -1">
                            <el-form-item label="检测公司:" prop="jc_company">
                                <el-input
                                v-model="form2.jc_company"
                                placeholder="请输入"
                                clearable
                                size="small"
                                
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="this.form2.laiyuan && this.form2.laiyuan.indexOf('检验') != -1">
                            <el-form-item label="报告编号:" prop="jc_jcbh">
                                <el-input
                                v-model="form2.jc_jcbh"
                                placeholder="请输入"
                                clearable
                                size="small"
                                
                                />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="this.form2.laiyuan && this.form2.laiyuan.indexOf('检验') != -1">
                            <el-form-item label="接收日期:" prop="jc_jieshoudate">
                                <el-date-picker size="small"
                                    v-model="form2.jc_jieshoudate"
                                    type="date" 
                                    placeholder="选择日期" value-format="yyyy-MM-dd"
                                    >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="this.form2.laiyuan && this.form2.laiyuan.indexOf('检验') != -1">
                            <el-form-item label="告知日期:" prop="jc_gaozhiDate">
                                <el-date-picker size="small"
                                    v-model="form2.jc_gaozhiDate"
                                    type="date" 
                                    placeholder="选择日期" value-format="yyyy-MM-dd"
                                    >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="this.form2.laiyuan && this.form2.laiyuan.indexOf('检验') != -1">
                            <el-form-item label="采样日期:" prop="jiancha_rq">
                                <el-date-picker size="small" @change="getContent11"
                                    v-model="form2.jiancha_rq"
                                    type="date" 
                                    placeholder="选择日期" value-format="yyyy-MM-dd"
                                    >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                            <!-- <el-col :span="6">
                            <el-form-item label="国家双随机:" prop="gjssj">
                                <el-radio-group v-model="form2.gjssj">
                                    <el-radio :label="'yes'">是</el-radio>
                                    <el-radio :label="'no'">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                            <el-col :span="6">
                            <el-form-item label="省级双随机:" prop="sjssj">
                                <el-radio-group v-model="form2.sjssj">
                                    <el-radio :label="'yes'">是</el-radio>
                                    <el-radio :label="'no'">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                            <el-col :span="6">
                            <el-form-item label="一般检查:" prop="isybjc">
                                <el-radio-group v-model="form2.isybjc">
                                    <el-radio :label="'yes'">是</el-radio>
                                    <el-radio :label="'no'">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                            <el-col :span="6">
                            <el-form-item label="投诉举报:" prop="istsjb">
                                <el-radio-group v-model="form2.istsjb">
                                    <el-radio :label="'yes'">是</el-radio>
                                    <el-radio :label="'no'">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col> -->
                            <el-col :span="8" v-if="!this.form2.laiyuan || (this.form2.laiyuan && this.form2.laiyuan.indexOf('检验') == -1)">
                            <el-form-item label="检查日期:" prop="jiancha_rq">
                                <el-date-picker size="small" style="width:140px;"  @change="getContent11"
                                    v-model="form2.jiancha_rq"
                                    type="date" 
                                    placeholder="选择日期" value-format="yyyy-MM-dd"
                                    >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                            <!-- <el-col :span="8">
                            <el-form-item label="受理日期:" prop="shouli_rq">
                                <el-date-picker size="small" style="width:140px;"
                                    v-model="form2.shouli_rq"
                                    type="date"
                                    placeholder="选择日期" value-format="yyyy-MM-dd"
                                    >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                            <el-col :span="6">
                            <el-form-item label="立案日期:" prop="lian_rq">
                                <el-date-picker size="small" style="width:140px;"
                                    v-model="form2.lian_rq"
                                    type="date"
                                    placeholder="选择日期" value-format="yyyy-MM-dd"
                                    >
                                </el-date-picker>
                            </el-form-item>
                        </el-col> -->
                            <!-- <el-col :span="18">
                            <el-form-item label="合议时间:">
                                <div style="overflow:hidden;">
                                <el-date-picker size="small" style="float:left; margin-right:10px;width:140px;"
                                    v-model="form2.heyisj"
                                    type="date"
                                    placeholder="选择日期" value-format="yyyy-MM-dd"
                                    >
                                </el-date-picker>
                                <el-time-picker style="float:left;"
                                    is-range size="small" editable
                                    v-model="form2.heyisj2"
                                    range-separator="至"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间"
                                    placeholder="选择时间范围" @change="getHysj" @input="getHysj">
                                </el-time-picker>
                            </div>
                            </el-form-item>
                        </el-col> -->
                            <el-col :span="24">
                            <el-form-item label="违反法律:" prop="law">
                                <el-input disabled
                                v-model="form2.law"
                                clearable
                                size="small" style="width:calc(100% - 200px);margin-right:10px;"
                                />
                                <el-button type="primary" size="small" @click="getFalv('违反法律',1)">违反法律</el-button>
                            </el-form-item>
                        </el-col>
                            <el-col :span="24">
                            <el-form-item label="处罚依据:" prop="punish_basis">
                                <el-input disabled
                                v-model="form2.punish_basis"
                                clearable
                                size="small" style="width:calc(100% - 200px);margin-right:10px;"
                                />
                                <el-button type="primary" size="small" @click="getFalv('处罚依据',2)">法律引用</el-button>
                            </el-form-item>
                        </el-col>
                            <el-col :span="24">
                            <el-form-item label="拟予处罚:">
                                <el-checkbox v-model="form2.jinggao" >警告</el-checkbox>
                                <el-checkbox name="type" v-model="form2.fakuan">
                                    <span>罚款</span>
                                    <el-input v-model="form2.fakuanJine" type="number" size="small" :style="{width: '130px'}" style="margin:0 10px;" 
                                    :disabled="!form2.fakuan" @input="form2.fakuanJine=form2.fakuanJine.replace(/[^\d.]/g,'')"></el-input>
                                    <span>元</span>
                                </el-checkbox>
                                <el-checkbox name="type" v-model="form2.moshou">
                                    <span>没收非法所得</span>
                                    <el-input v-model="form2.moshouJine" type="number" size="small" :style="{width: '130px'}" style="margin:0 10px;" 
                                    :disabled="!form2.moshou" @input="form2.moshouJine=form2.moshouJine.replace(/[^\d.]/g,'')"></el-input>
                                    <span>元</span>
                                </el-checkbox>
                                <el-checkbox v-model="form2.isdx" @change="getDxnrtk">吊销{{text1}}</el-checkbox>
                                <el-checkbox v-model="form2.iszl" @change="getZlnrtk">{{text2}}</el-checkbox>
                                <el-checkbox name="type" v-model="form2.moshou2">
                                    <span>没收</span>
                                    <el-input v-model="form2.txtWupin" size="small" :style="{width: '130px'}" style="margin:0 10px;" 
                                    :disabled="!form2.moshou2" ></el-input>
                                </el-checkbox>
                                <el-checkbox v-model="form2.buyuChufa" >不予处罚</el-checkbox>
                            </el-form-item>
                        </el-col>
                            <el-col :span="6">
                            <el-form-item label="经办科室:" prop="jingbanks">
                                <el-select v-model="form2.jingbanks" placeholder="请选择" size="small" style="width:120px;">
                                    <el-option
                                        v-for="(dict,index) in ksOptions"
                                        :key="index"
                                        :label="dict.gzbm"
                                        :value="dict.gzbm"
                                        ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                            <el-col :span="6">
                            <el-form-item label="主办人员:" prop="host_man">
                                <el-select v-model="form2.host_man" placeholder="请选择" size="small" style="width:120px;">
                                    <el-option
                                        v-for="(dict,index) in userOptions"
                                        :key="index"
                                        :label="dict.xm"
                                        :value="dict.xm"
                                        ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                            <el-col :span="6">
                            <el-form-item label="协办人员:" prop="xiebanren">
                                <el-select v-model="form2.xiebanren" placeholder="请选择" size="small" style="width:120px;">
                                    <el-option
                                    v-for="(dict,index) in userOptions"
                                        :key="index"
                                            :label="dict.xm"
                                            :value="dict.xm"
                                        ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                            <!-- <el-col :span="6">
                            <el-form-item label="实际主办人员:" prop="factHost">
                                <el-select v-model="form2.factHost" placeholder="请选择" size="small" style="width:120px;" @change="getHostdh">
                                    <el-option
                                        v-for="(dict,index) in userOptions"
                                        :key="index"
                                            :label="dict.xm"
                                            :value="dict.xm"
                                        ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col> -->
                            <!-- <el-col :span="6">
                            <el-form-item label="主办人电话:" prop="hostdh">
                                <el-input disabled
                                v-model="form2.hostdh"
                                placeholder="请输入"
                                clearable
                                size="small" style="width:120px;"
                                />
                            </el-form-item>
                        </el-col> -->
                            <!-- <el-col :span="18">
                            <el-form-item label="合议人员:" prop="join_man">
                                <el-select v-model="form2.join_man" placeholder="请选择" size="small" style="width:120px;">
                                    <el-option
                                        v-for="(dict,index) in userOptions"
                                        :key="index"
                                            :label="dict.xm"
                                            :value="dict.xm"
                                        ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col> -->
                            <el-col :span="24">
                            <el-form-item label="主案由:" prop="reason2">
                                <el-input disabled
                                v-model="form2.reason1"
                                placeholder="请输入"
                                clearable
                                size="small" style="width:200px;margin-right:10px;"
                                />
                                <el-input disabled
                                v-model="form2.reason2"
                                placeholder="请输入"
                                clearable
                                size="small"  style="width:calc(100% - 410px);margin-right:10px;"
                                />
                                <el-button type="primary" size="small" @click="getAnyou('主案由',1)">选择模板</el-button>
                                <el-button type="primary" size="small" @click="addAy()">增加从案由</el-button>
                            </el-form-item>
                        </el-col>
                            <el-col :span="24" v-show="(form2.reason22 && form2.reason22 != '无') || isCay">
                            <el-form-item label="从案由:" prop="reason22">
                                <el-input disabled
                                v-model="form2.reason1"
                                placeholder="请输入"
                                clearable
                                size="small" style="width:200px;margin-right:10px;"
                                />
                                <el-input disabled
                                v-model="form2.reason22"
                                placeholder="请输入"
                                clearable
                                size="small"  style="width:calc(100% - 476px);margin-right:10px;"
                                />
                                <el-button type="primary" size="small" @click="getAnyou('从案由',2)">选择模板</el-button>
                                <el-button type="primary" size="small" @click="addAnyou()">增加从案由</el-button>
                                <el-button type="danger" size="small" @click="delectReason22()">删除</el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24" v-show="isAy > 1">
                            <el-form-item v-for="(item,index) in form2.domains" :key="index" :label="'从案由'+item.key+':'" >
                                <el-input
                                v-model="form2.reason1"
                                placeholder="请输入"
                                clearable
                                size="small" style="width:200px;margin-right:10px;"
                                />
                                <el-input disabled
                                v-model="item.value"
                                placeholder="请输入"
                                clearable
                                size="small"  style="width:calc(100% - 410px);margin-right:10px;"
                                />
                                <el-button type="primary" size="small" @click="getAnyou('从案由',2,index)">选择模板</el-button>
                                <el-button type="danger" size="small" @click="delectAnyou(index)">删除</el-button>
                            </el-form-item>
                        </el-col>
                            <el-col :span="24"  v-show="(form2.reason22 && form2.reason22 != '无') || isCay">
                            <el-form-item label="合并案由:" prop="hbay">
                                <el-input disabled
                                v-model="form2.reason1"
                                placeholder="请输入"
                                clearable
                                size="small" style="width:200px;margin-right:10px;"
                                />
                                <el-input disabled
                                v-model="form2.Hreason22"
                                placeholder="请输入"
                                clearable
                                size="small" style="width:calc(100% - 410px);margin-right:10px;"
                                />
                                <el-button type="primary" size="small" @click="getHbAnyou()">合并案由</el-button>
                            </el-form-item>
                        </el-col>
                            <el-col :span="12">
                            <el-form-item label="告知书文号:" prop="gzswh">
                                <span>{{wenhao}}</span>
                                <el-select  size="small" v-model="form2.gzsno2" placeholder="请选择执法类别" clearable  style="margin:0 10px;width: 60px;" @change="getNo()" >
                                    <el-option value="水">水</el-option>
                                    <el-option value="学">学</el-option>
                                    <el-option value="医">医</el-option>
                                    <el-option value="职">职</el-option>
                                    <el-option value="传">传</el-option>
                                    <el-option value="放">放</el-option>
                                    <el-option value="公">公</el-option>
                                    <el-option value="血液">血液</el-option>
                                    <el-option value="消">消</el-option>
                                    <el-option value="计生">计生</el-option>
                                    <el-option value="爱">爱</el-option>
                                </el-select>
                                <span>罚告</span>
                                <!-- <el-input size="small" v-model="form2.gzsno3" :style="{width: '20%'}" style="margin:0 10px;" @change="getNo3()"></el-input> -->
                                <el-select  size="small" v-model="form2.gzsno3" placeholder="请选择" clearable style="margin:0 10px; width:80px;" @change="getNo3()" >
                                    <el-option v-for="(item,index) in yearOptions" :key="index" :label="item" :value="item"></el-option>
                                </el-select>
                                <el-input size="small" v-model="form2.gzsno4" :style="{width: '20%'}"  @change="getNo4()"></el-input>
                                <span style="margin-left:10px;">号</span>
                            </el-form-item>
                        </el-col>
                            <el-col :span="12">
                            <el-form-item label="决定书文号:" prop="jdswh">
                                <span>{{wenhao}}</span>
                                <el-select  size="small" v-model="form2.jdsno2" placeholder="请选择" clearable style="margin:0 10px; width:60px;" @change="getNoa()" >
                                    <el-option value="水">水</el-option>
                                    <el-option value="学">学</el-option>
                                    <el-option value="医">医</el-option>
                                    <el-option value="职">职</el-option>
                                    <el-option value="传">传</el-option>
                                    <el-option value="放">放</el-option>
                                    <el-option value="公">公</el-option>
                                    <el-option value="血液">血液</el-option>
                                    <el-option value="消">消</el-option>
                                    <el-option value="计生">计生</el-option>
                                    <el-option value="爱">爱</el-option>
                                </el-select>
                                <span>罚</span>
                                <!-- <el-input size="small" v-model="form2.jdsno3" :style="{width: '20%'}" style="margin:0 10px;" @change="getNo3()">
                                </el-input> -->
                                <el-select  size="small" v-model="form2.jdsno3" placeholder="请选择执法类别" clearable style="margin:0 10px; width:80px;" @change="getNoa3()" >
                                    <el-option v-for="(item,index) in yearOptions" :key="index" :label="item" :value="item"></el-option>
                                </el-select>
                                <el-input size="small" v-model="form2.jdsno4" :style="{width: '20%'}"  @change="getNoa4()"></el-input>
                                <span style="margin-left:10px;">号</span>
                            </el-form-item>
                            </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </el-card>
                <el-card class="box-card" style="text-align:center;">
                    
                    <!-- <el-button type="warning" size="medium" @click="provinceData">省数据同步</el-button> -->
                    <!-- <el-button type="warning" size="medium" @click="handleAdd">智能评测</el-button>
                    <el-button type="warning" size="medium" @click="handleAdd">预览评查表</el-button> -->
                    <el-button type="primary" size="medium" @click="handleSubmit">保存</el-button>
                    <el-button type="primary" size="medium" v-if="xgType==1" @click="save(1)"> 暂  存 </el-button>
                </el-card>
                <!-- v-if="isShowxcbl || form2.content12" -->
                <!--form2.content12的按钮 <el-button type="primary" size="small" @click="getBacl()">并案处理</el-button> -->
                <div slot="header" class="clearfix">
                    <span class="text">三、案情摘要（<b style="color:red;">注：以下数据从省系统同步，无需录入！</b>）</span>
                </div>
                <div class="box-cont">
                    <el-form :model="form2" ref="queryForm3" label-width="140px">
                        <el-form-item label="现场笔录记录内容:" prop="content12">
                            <p style="background:#ffff00;">{{form2.content11}}</p>
                            <el-input type="textarea" :rows="5"
                            v-model="form2.content12" size="small"
                            />
                            <div class="btns">
                                
                                <el-button type="primary" size="small" @click="getBlzdy()">选择模板</el-button>
                                <el-button type="primary" size="small" @click="getFuzhi(form2.content12)">复制内容</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="调查询问过程描述:" prop="content2">
                            <p style="background:#ffff00;">{{aj_list.xwms}}</p>
                            <el-input type="textarea" :rows="5"
                            v-model="form2.content2"
                            />
                            <div class="btns">
                                <el-button type="primary" size="small" @click="getXwtk()">选择模板</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="违法事实:" prop="content3">
                            <el-input type="textarea" :rows="5"
                            v-model="form2.content3"
                            />
                            <div class="btns">
                                <el-button type="primary" size="small" @click="getWfss()">选择模板</el-button>
                                <el-button type="primary" size="small" @click="getFuzhi(form2.content3)">复制内容</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="本案取得的证据:" prop="content4">
                            <el-input type="textarea" :rows="5"
                            v-model="form2.content4"
                            />
                            <div class="btns">
                                <el-button type="primary" size="small" @click="getBazj()">选择模板</el-button>
                                <el-button type="primary" size="small" @click="getFuzhi(form2.content4)">复制内容</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="案件调查终结报告上的处理建议:" prop="content5">
                            <p style="background:#ffff00;">当事人的行为违反了{{form2.law}}的规定，依据{{form2.punish_basis}}，</p>
                            <el-input type="textarea" :rows="5"
                            v-model="form2.content5"
                            />
                            <div class="btns">
                                <el-button type="primary" size="small" @click="getCljy()">通用模板</el-button>
                                <el-button type="primary" size="small" >固定模板</el-button>
                            </div>
                        </el-form-item>
                        <el-form-item label="合议记录（告知书、决定书）上的说理内容:" prop="content6">
                            <p style="background:#ffff00;">本机关认为：</p>
                            <el-input type="textarea" :rows="5"
                            v-model="form2.content6"
                            />
                            <div class="btns">
                                <el-button type="primary" size="small" @click="getSlnr()">选择模板</el-button>
                            </div>
                        </el-form-item>
                        
                    </el-form>
                </div>
                <!-- <el-form-item style="text-align:center;">
                        <el-button type="primary" size="small" @click="provinceData">省数据同步</el-button>
                        <el-button type="primary" size="small" @click="handleAdd">智能评测</el-button>
                        <el-button type="primary" size="small" @click="handleAdd">预览评查表</el-button>
                        <el-button type="primary" size="small" @click="handleAdd">保存上报</el-button>
                    </el-form-item> -->
            </el-col>
            <el-col :span="5">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span class="text">文书</span>
                    </div>
                    <div class="box-cont">
                        <!-- <div class="demo-input-suffix">
                            <el-input class="search"
                                placeholder="请输入文书名称查询"
                                v-model="wsName">
                                <i slot="suffix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                        </div> -->
                        <ul>
                            <li v-for="(item,index) in wsList" :key="index">
                                <!-- <p>
                                    <span @click="showEdit(item)">{{item.wsName}}</span>
                                    <i v-if="item.isWc" class="el-icon-document" @click="show(item,0)"></i>
                                    <i v-if="item.isWc" class="el-icon-edit" @click="bianjiWord(item,2)" style="margin-right:10px;"></i>
                                </p> -->
                                
                                <p class="liebiao"> 
                                    <span @click="showEdit(item)" @mouseenter="mouseenter">
                                        <el-tooltip class="item" effect="dark" :content="item.wsName" placement="left">
                                            <el-button>{{item.wsName}}</el-button>
                                        </el-tooltip>
                                    </span>
                                    <i v-if="item.isWc" class="el-icon-document" @click="wordEdit(item)"></i>
                                    <!-- <i v-if="item.isWc" class="el-icon-edit" @click="bianjiWord(item,2)" style="margin-right:10px;"></i>
                                    <i v-if="item.isWc" class="el-icon-edit" @click="bianjiWord(item,2)" style="margin-right:10px;"></i> -->
                                </p>
                                
                            </li>
                        </ul>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog :title="title" :visible.sync="open" top="5vh" :width="width" append-to-body :close-on-click-modal="false" @close='closeDialog'>
            <xwbl v-if="this.code == 'xwbl'" :code="this.code" :pcId="this.ajId" :jingyingzhe="this.form1.jingyingzhe" @handleBack="handleBack" :key="Math.round()"  />
            <xcbl v-else-if="this.code == 'xcbl'" :code="this.code" :dwmc="this.form1.dwmc" :pcId="this.ajId" :hysj="this.form2.heyisj" :jdy1="this.form2.host_man" :jdy2="this.form2.xiebanren" @handleBack="handleBack"  />
            <jdyjs v-else-if="this.code == 'wsjdyjs'" :code="this.code" :pcId="this.ajId" :text="this.form2.content3" :anyou="this.form2.reason2" :cfyj="this.form2.punish_basis" @handleBack="handleBack"  />
            <cyjl v-else-if="this.code == 'cyjl'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <zdjttl v-else-if="this.code == 'zdjttl'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <zdfzsh v-else-if="this.code == 'zdfzsh'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack" :wfss="this.form2.content3" :zhengju="this.form2.content4" :falv="this.falv" :anyou="this.anyou"  />
            <xczpzj v-else-if="this.code == 'xczpzj'" :code="this.code" :pcId="this.ajId" :dwdz="this.form1.dwdz" :dwmc="this.form1.dwmc" :jcrq="this.form2.jiancha_rq" :mid="this.dwId" :lsh="this.lsh" @handleBack="handleBack"  />
            <yjyzz v-else-if="this.code == 'yjyzz'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <jsjdwts v-else-if="this.code == 'jsjdwts'" :code="this.code" :pcId="this.ajId" :pre="this.wenhao"  :dwmc="this.form1.dwmc" @handleBack="handleBack"  />
            <jyjggzs v-else-if="this.code == 'jyjggzs'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <cfajfm v-else-if="this.code == 'cfajfm'" :code="this.code" :pcId="this.ajId" :rq="this.form2.jiancha_rq" @handleBack="handleBack"  />
            <cfajml v-else-if="this.code == 'cfajml'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <sdhz v-else-if="this.code == 'sdhz'" :code="this.code" :pcId="this.ajId" :dwId="this.form1.mid" :dwFlag="this.form1.dw_flag" @handleBack="handleBack"  />
            <jnbkb v-else-if="this.code == 'jnbkb'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <jdyzfz v-else-if="this.code == 'jdyzfz'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <sxspzjjds v-else-if="this.code == 'sxspzjjds'" :code="this.code" :pcId="this.ajId" :pre="this.wenhao" @handleBack="handleBack"  />
            <sxspzjcljds v-else-if="this.code == 'sxspzjcljds'" :code="this.code" :pcId="this.ajId" :pre="this.wenhao" @handleBack="handleBack"  />
            <zjxxdjbcjds v-else-if="this.code == 'zjxxdjbcjds'" :code="this.code" :pcId="this.ajId" :pre="this.wenhao" @handleBack="handleBack"  />
            <zjxxdjbccljds v-else-if="this.code == 'zjxxdjbccljds'" :code="this.code" :pcId="this.ajId" :pre="this.wenhao" @handleBack="handleBack"  />
            <fp v-else-if="this.code == 'fp'" :code="this.code" :pcId="this.ajId" @handleBack="handleBack"  />
            <span v-else>9999</span>
        </el-dialog>

        <el-dialog title="现场笔录信息" :visible.sync="open2" top="5vh" width="1200px" append-to-body :close-on-click-modal="false">
            <el-form :model="queryParams" ref="queryForm" :inline="true">
                <el-form-item label="单位名称(个人名称):" prop="dwmc">
                    <el-input style="width:340px;"
                    v-model="queryParams.dwmc"
                    placeholder="请输入单位名称(个人名称)"
                    clearable
                    size="small"
                    />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">搜索</el-button>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="isXcbl" @change="getIsXcbl">无需现场笔录</el-checkbox>
                </el-form-item>
            </el-form>
            <div style="max-height:500px;overflow-y:auto;">
            <el-table v-loading="loading" :data="xcblList">
                        <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="60">
                            <template slot-scope="scope">
                                <span>{{(scope.$index+1)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="单位名称" prop="dwmc" />
                        <el-table-column label="执法类别" align="center" prop="ssjType" width="110"  />
                        <el-table-column label="处罚" prop="ischufa" width="50"  />
                        <el-table-column label="检测" prop="isjiance" width="50" />
                        <el-table-column label="专业类别" prop="zflb" width="90" />
                        <el-table-column label="检查人员1" align="center" prop="jdy1" width="90" />
                        <el-table-column label="检查人员2" align="center" prop="jdy2"  width="90" />
                        <el-table-column label="检查日期" align="center" prop="bl_date" width="110"  />
                        <el-table-column label="记录有无" align="center" width="80" >
                            <template slot-scope="scope">
                                <span v-if="scope.row.xcbl_bh">有</span>
                                <span v-else>无</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="选择" align="center" class-name="small-padding fixed-width" width="100" >
                            <template slot-scope="scope">
                               <el-checkbox v-model="scope.row.checked" @change="handleSelect(scope.row,scope.$index)"></el-checkbox>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                    <div style="text-align:center;">
                        <el-button type="primary" @click="queding">确 定</el-button>
                    </div>
                    <!-- <div class="page-part" style="padding:20px 20px 50px;">
                        <el-pagination  v-if="pageshow"
                            background
                            @size-change='handleSizeChange'
                            @current-change='handleCurrentChange'
                            :current-page="queryParams.page"
                            :page-sizes="[10,20,30,40]"
                            :page-size="queryParams.limit"
                            layout="total, prev, pager, next, jumper"
                            :total="total" style=" float:right;">
                        </el-pagination>
                    </div> -->
        </el-dialog>

        <el-dialog :title="title3" :visible.sync="open3" top="5vh" width="1200px" append-to-body :close-on-click-modal="false">
            <falv :leixing="this.leixing" :text="this.title3" @handleBack="handleBackFalv" @falvTk="closeFalv" />
        </el-dialog>

        <el-dialog :title="title4" :visible.sync="open4" top="5vh" width="1200px" append-to-body :close-on-click-modal="false">
            <anyou :leixing="this.leixing2" :text="this.title4" :lshId="this.ajId" @handleBack="handleBackAnyou" @closeTk="closeAnyou"  />
        </el-dialog>

        <el-dialog title="请输入并案理由" :visible.sync="open5" width="500px" append-to-body :close-on-click-modal="false">
            <el-input type="textarea" :rows="8" placeholder="请输入并案理由" v-model="baly" />
            <div style="margin-top:20px; text-align:right;">
                <el-button type="primary" size="small" @click="balyTj">提交</el-button>
                <el-button type="info" size="small" @click="open5 = false">取消</el-button>
            </div>
        </el-dialog>
        <el-dialog title="" :visible.sync="open6" width="500px" append-to-body :close-on-click-modal="false">
            <div>
                <br/>
                <el-form label-width="100px">
                    <el-form-item label="吊销" prop="dxnr" >
                        <el-input v-model="dxnr" placeholder="" clearable  size="small" style="width:80%;" />
                    </el-form-item>
                </el-form>
                <p style="text-align:center;">
                        <el-button type="primary" size="small" @click="getDxnr">确定</el-button>
                </p>
                <br/>
                <p style="color:red;"><b>备注：请注明吊销的详细内容，譬如：内科的诊疗科目，而不能是“内科”二字。</b></p>
            </div>
        </el-dialog>
        <el-dialog title="" :visible.sync="open7" width="500px" append-to-body :close-on-click-modal="false">
            <div>
                <el-radio-group v-model="zllx" @change="getZl" style="margin:20px 0;">
                    <el-radio label="责令停产">责令停产</el-radio>
                    <el-radio label="责令停业">责令停业</el-radio>
                    <el-radio label="暂停执业">暂停执业</el-radio>
                </el-radio-group>
                <el-form label-width="100px" :inline="true">
                    <el-form-item prop="zlnr" >
                        <el-input v-model="zlnr" placeholder="" clearable  size="small" style="width:80%;" :disabled="zllx == '暂停执业' ? false : true" />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="getZlnr">确定</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
        <el-dialog title="省系统信息同步" :visible.sync="open8" width="1000px" append-to-body :close-on-click-modal="false">
            <div>
                <p>温馨提醒！</p>
                <p>1.未查到此单位在"浙江省数智卫监精密智控系统"里受理与立案信息，请进入省系统受理与立案。</p>
                <p>2.如已核实此单位在省系统中已经受理与立案，请关闭此窗口，重新进行省系统数据同步。</p>
                <p>3.如无需同步省系统的数据，请点击继续保存上报</p>
                <el-button type="primary" >进入数智卫监精密智控系统</el-button>
                <el-button type="danger" @click="open8 = false">继续保存上报</el-button>
            </div>
        </el-dialog>

        <el-dialog title="笔录记录检查内容" :visible.sync="open9" width="1000px" append-to-body :close-on-click-modal="false">
            <!-- <el-input type="textarea" :rows="8" placeholder="请输入笔录记录内容" v-model="blnr" />
            <div style="margin-top:20px; text-align:right;">
                <el-button type="primary" size="small" @click="zdyblTj">提交</el-button>
                <el-button type="info" size="small" @click="">取消</el-button>
            </div> -->
            <div class="nr">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <ul class="zfmb" style="max-height:500px;overflow-y: auto;">
                            <li v-for="(item,index) in zfmbList" :key="index">
                            <p @click="getActive(index)"><i :class="isActive == index?'icon2':'icon1'" style="color:#ffaf47;"></i><b>{{item.zylbMc}}</b></p>
                            <div v-show="isActive == index" class="zfmb2">
                                <span v-for="(itema,i) in item.info" :key="i" :class="isActive2 == i?'dqSpan':''" @click="getXunwennr(itema,i)">{{itema.mcjianxie}}</span>
                            </div>
                            </li>
                        </ul>
                    </el-col>
                    <el-col :span="16">
                        <el-form>
                            <!-- <el-form-item label="" prop="wfss">
                                <el-checkbox v-model="form2.wfss" @change="getXz">违法事实</el-checkbox>
                            </el-form-item> -->
                            <el-form-item label="">
                                <el-input type="textarea" rows="16" v-model="blnr" />
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button  size="small" type="primary" @click="zdyblTj">确定</el-button>
                    <el-button  size="small" @click="open9 = false">取消</el-button>
                </div>
            </div>
        </el-dialog>


        <el-dialog title="调查询问过程描述" :visible.sync="open10" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <xunwen :text="this.form2.content2" @handleBackXunwen="handleBackXunwen" @xunwenTk="closeXunwen"  />
        </el-dialog>

        <el-dialog title="违法事实" :visible.sync="open11" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <shishi :text="this.form2.content3" @handleBackShishi="handleBackShishi" @shishiTk="closeShishi"  />
        </el-dialog>

        <el-dialog title="本案取得的证据" :visible.sync="open12" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <zhengju :text="this.form2.content4" @handleBackZhengju="handleBackZhengju" @zhengjuTk="closeZhengju"  />
        </el-dialog>

        <el-dialog title="终结报告上的处理建议" :visible.sync="open13" top="5vh" width="1200px" append-to-body :close-on-click-modal="false">
            <jianyi :text="this.form2.content5" @handleBackJianyi="handleBackJianyi" @jianyiTk="closeJianyi"  />
        </el-dialog>

        <el-dialog title="合议记录上的说理内容" :visible.sync="open14" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <shuoli :text="this.form2.content6" :law="this.form2.law" :cfyj="this.form2.punish_basis" :cljy="this.form2.content5" @handleBackShuoli="handleBackShuoli" @shuoliTk="closeShuoli"  />
        </el-dialog>


        <el-dialog v-loading="loadingWord" title="询问笔录" :visible.sync="dialogFormVisible">
            <el-form>
                <el-form-item label="询问笔录：" label-width="100px">
                    <el-select v-model="xwblText" placeholder="" size="small"  style="width:200px;" @change="getYlText()">
                        <el-option
                            v-for="dict in blOptions"
                            :key="dict.blLsh"
                            :label="dict.name"
                            :value="dict.blLsh"
                            ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
            <p style="margin-bottom:20px;">
                <el-button size="small" type="danger" @click="edit3()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                <el-button size="small" type="primary" @click="resetWord3()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                <el-button size="small" type="warning" @click="show3()" icon="el-icon-view">预 览</el-button>
            </p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <!-- <el-button type="primary" @click="show3()">预 览</el-button>
                <el-button type="primary" @click="edit3()">编 辑</el-button> -->
            </div>
        </el-dialog>

        <el-dialog v-loading="loadingWord" title="现场照片" :visible.sync="dialogFormVisible2">
            <el-form>
                <el-form-item label="现场照片：" label-width="100px">
                    <el-select v-model="xczpText" placeholder="" size="small"  style="width:200px;" @change="getXcText()">
                        <el-option
                            v-for="dict in xczpOptions"
                            :key="dict.blLsh"
                            :label="dict.name"
                            :value="dict.blLsh"
                            ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
            <p style="margin-bottom:20px;">
                
                <el-button size="small" type="danger" @click="edit4()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                <el-button size="small" type="primary" @click="resetWord4()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                <el-button size="small" type="warning" @click="show4()" icon="el-icon-view">预 览</el-button>
            </p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible2 = false">取 消</el-button>
                <!-- <el-button type="primary" @click="show4()">预 览</el-button>
                <el-button type="primary" @click="edit4()">编 辑</el-button> -->
            </div>
        </el-dialog>

        <el-dialog :title="titleWord" :visible.sync="dialogWordVisible">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>


        <el-dialog title="请选择类型" :visible.sync="openTb" width="500px">
            <div>
                <p style="margin-bottom:20px;font-size:16px;">请先选择案件信息同步的类型：</p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button size="medium" type="primary" @click="tbType(0)">进行中</el-button>&nbsp;&nbsp;
                    <el-button size="medium" type="success" @click="tbType(1)">已结案</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog title="案件信息同步" :visible.sync="openTb2" width="1200px" append-to-body :close-on-click-modal="false">
            <div style="max-height:500px;overflow-y:auto; margin-bottom:20px;">
                <el-table v-loading="loading8" :data="sxxList">
                    <el-table-column label="立案文号" align="center" prop="filingCode" width="110" />
                    <el-table-column label="执法人员1" align="center" prop="punishPersonnelName1" width="85"  />
                    <el-table-column label="执法人员2" align="center" prop="punishPersonnelName2" width="85"  />
                    <el-table-column label="单位名称" prop="compName" />
                    <el-table-column label="专业" align="center" prop="speSec" width="90" />
                    <el-table-column label="案件名称" prop="punishActionName" />
                    <el-table-column label="处罚节点" align="center" prop="codeName"  width="80" />
                    <el-table-column label="受理日期" align="center" prop="acceptTime" width="110"  />
                    <el-table-column label="立案日期" align="center" prop="recordDate" width="110"  />
                    <el-table-column label="选择" align="center" class-name="small-padding fixed-width" width="100" >
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.checked" :checked="scope.row.checked" @change="handleSelectTb(scope.row,scope.$index)"></el-checkbox>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-show="sxxList.length > 0" style="text-align:center;">
                <el-button type="primary" @click="quedingTb">数据同步</el-button>
            </div>
        </el-dialog>

        <div v-show="tbLoading" class="loading" style="z-index:9999;">
            <i class="el-icon-loading"></i>
            <p>{{tbText}}</p>
        </div>
    </div>
</template>

<script>
import xwbl from '../wslb/xwbl.vue'
import xcbl from '../wslb/xcbl.vue'
import jdyjs from '../wslb/jdyjs.vue'
import cyjl from '../wslb/cyjl.vue'
import jyjggzs from '../wslb/jyjggzs.vue'
import zdjttl from '../wslb/zdjttl.vue'
import zdfzsh from '../wslb/zdfzsh.vue'
import xczpzj from '../wslb/xczpzj.vue'
import yjyzz from '../wslb/yjyzz.vue'
import jsjdwts from '../wslb/jsjdwts.vue'
import sxspzjjds from '../wslb/sxspzjjds.vue'
import sxspzjcljds from '../wslb/sxspzjcljds.vue'
import zjxxdjbcjds from '../wslb/zjxxdjbcjds.vue'
import zjxxdjbccljds from '../wslb/zjxxdjbccljds.vue'
import cfajfm from '../wslb/cfajfm.vue'
import cfajml from '../wslb/cfajml.vue'
import sdhz from '../wslb/sdhz.vue'
import jnbkb from '../wslb/jnbkb.vue'
import jdyzfz from '../wslb/jdyzfz.vue'
import fp from '../wslb/fp.vue'

import falv from './falv.vue'
import anyou from './anyou.vue'
import xunwen from './xunwen.vue'
import shishi from './shishi.vue'
import zhengju from './zhengju.vue'
import jianyi from './jianyi.vue'
import shuoli from './shuoli.vue'

import axios from 'axios'
import qs from 'qs'

export default {
    name: "baxq",
    // props:['ajId','dwId','dwFlag','ajFlag','isNew','row'],
    data() {
        return {
            loading:false,
            tbLoading:false,
            loading8:false,
            tbText:'数据同步中...',
            ahId:'',
            dwId:'',
            dwFlag:'',
            ajFlag:'',
            lsh:'',
            isNew:1,
            xgType:1,
            row:{},
            bz:'',
            dm:'',
            xm:'',
            cmid:'',
            dwForm:{},
            form1:{},
            form2:{
                wenhaopre:'',
                spLsh:'',
                bl_lsh:'',
                dwmc_id:'',
                jiancha_rq:'', 
                jc_rq:'',
                laiyuan:'',
                lian_rq:'',
                shouli_rq:'', 
                aj_shouli_rq:'',
                heyisj:'',
                heyisj_begin:'',
                heyisj_end:'',
                jinggao:false, 
                fakuan:false, 
                fakuanJine:'', 
                moshou:false, 
                moshouJine:'', 
                moshou2:false, 
                txtWupin:'', 
                law:null,
                punish_basis:null,
                jingbanks:null,
                host_man:null,
                hostdh:null,
                factHost:null,
                xiebanren:null,
                join_man:null,
                reason1:null,
                reason2:null,
                reason22:null,
                Hreason22:null,
                lianWenhao:null,
                gzsno2:null,
                gzsno3:null,
                gzsno4:null,
                jdsno2:null,
                jdsno3:null,
                jdsno4:null,
                content11:null,
                dashuju:null,
                content12:null,
                content2:null,
                content3:null,
                content4:null,
                content5:null,
                content6:null,
                dwdz:null,
                xkzh:null,
                fzr:null,
                xb:null,
                nation:null,
                zw: null,
                tyshxydm:null,
                sfzh: null,
                sj1: null,
                dwdz2:null,
                xkzh2:null,
                fzr2:null,
                xb2:null,
                nation2:null,
                zw2: null,
                tyshxydm2: null,
                sfzh2: null,
                sj12:null,
                ts_shijian:'',
                ts_nr:null,
                jc_company:'',
                jc_jcbh:null,
                jc_jieshoudate:'',
                jc_gaozhiDate:'',
                content112:null,
                content113:null,
                sjssj:null,
                gjssj:null,
                isybjc:null,
                istsjb:null,
                dxxkz:null,
                zltcty:null,
                xwbl_splsh:null,
                zyclid:null,
                buyuChufa:null,
                isnoxcbl:null,
                strpunishCaseCode:null,
                domains:[],
            },
            form3:{},
            xbOptions:[
                {id:1,label:'男'},
                {id:2,label:'女'}
            ],
            jingyingzheOptions:[],
            mzOptions:[],
            zwOptions:[],
            lyOptions:[],
            ksOptions:[],
            userOptions:[],
            dhOptions:[],
            whpreOptions:[],
            aj_list:[],
            open:false,
            wsList:[
                {wsCode:'xwbl',wsName:'询问笔录',wsname: "xunwenbilu",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                {wsCode:'xcbl',wsName:'现场笔录',wsname: "xianchangbilu",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                {wsCode:'wsjdyjs',wsName:'卫生监督意见书',wsname: "weishengjianduyijianshu",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                {wsCode:'jyjggzs',wsName:'检验结果告知书',wsname: "jianyanjieguogaozhishu",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                {wsCode:'zdjttl',wsName:'重大案件集体讨论',wsname: "jititaolunbilu",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                {wsCode:'zdfzsh',wsName:'重大案件法制审核表',wsname: "fazhishenhebiao",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                {wsCode:'xczpzj',wsName:'现场照片证据',wsname: "xianchangzhaopian",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                {wsCode:'yjyzz',wsName:'原件一致章',wsname: "",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                
                {wsCode:'zjxxdjbcjds',wsName:'证据先行登记保存决定书',wsname: "zhengjuxianxingdengjibaocunjuedingshu",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                
                {wsCode:'sxspzjjds',wsName:'行政执法事项审批表(证据先行登记保存决定)',wsname: "xingzhengzhifashixiangshenpibiao(zhengjuxianxingdengjibaocunjueding)",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                {wsCode:'zjxxdjbccljds',wsName:'证据先行登记保存处理决定书',wsname: "zhengjuxianxingdengjibaocunchulijuedingshu",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                {wsCode:'sxspzjcljds',wsName:'行政执法事项审批表(证据先行登记保存处理决定)',wsname: "xingzhengzhifashixiangshenpibiao(zhengjuxianxingdengjibaocunchulijueding)",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                
                // {wsCode:'cyjl',wsName:'采样记录',isWc:false},
                // {wsCode:'fcpcyjl',wsName:'非产品采样记录',isWc:false},
                {wsCode:'cfajfm',wsName:'处罚案卷封面',wsname: "chufaanjuanfengmian",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                {wsCode:'cfajml',wsName:'处罚案卷目录',wsname: "chufaanjuanmulu",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                {wsCode:'sdhz',wsName:'送达回执',wsname: "songdahuizhi",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                {wsCode:'jnbkb',wsName:'卷内备考表',wsname: "juanneibeikaobiao",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: "",docurl:""},
                // {wsCode:'jdyzfz',wsName:'监督员执法证',isWc:false},
                // {wsCode:'fp',wsName:'发票',isWc:false},
                
            ],
            cfCheck:[],
            wsName:'',
            title:'',
            open:false,
            code:'',
            width:'1000px',
            open2:false,
            queryParams:{
                dwmc:'',
                page:1,
                limit:10,
            },
            isXcbl:false,
            total:0,
            xcblList:[],
            pageshow:true,
            checked:false,
            open3:false,
            title3:'',
            leixing:'',
            open4:false,
            title4:'',
            leixing2:'',
            open5:false,
            baly:'',
            isAy:1,
            open6:false,
            open7:false,
            open8:false,
            dxnr:'',
            text1:'',
            text2:'',
            zllx:'',
            zlnr:'',
            open9:false,
            blnr:'',
            zfmbList:[],
            isActive:'-1',
            isActive2:'-1',
            open10:false,
            textXw:'',
            open11:false,
            open12:false,
            open13:false,
            open14:false,
            wenhao:'',
            bjRow:{},
            org:'',
            isShowxcbl:false,
            blOptions:[],
            xwblText:'',
            dialogFormVisible:false,
            blList:[],
            xcblname:'',
            falv:'',
            anyou:'',
            cbyj:'',
            yearOptions:[],
            bcType:1,
            dialogFormVisible2:false,
            xczpText:'',
            xczpOptions:[],
            zpList:[],
            iswsBj:0,
            dqWord:{},
            titleWord:'',
            dialogWordVisible:false,
            loadingWord:false,
            xkzText:'卫生许可证号:',
            isCay:false,
            xcblIs:false,
            openTb:false,
            openTb2:false,
            sxxList:[],
            tbRow:{},
            tbCode:0,
            tbtype:0,
            baseUrl:''
        }
    },
    components: {
        xwbl,
        xcbl,
        jdyjs,
        jyjggzs,
        cyjl,
        zdjttl,
        zdfzsh,
        xczpzj,
        yjyzz,
        jsjdwts,
        sxspzjjds,
        sxspzjcljds,
        zjxxdjbcjds,
        zjxxdjbccljds,
        cfajfm,
        cfajml,
        sdhz,
        jnbkb,
        jdyzfz,
        fp,
        falv,
        anyou,
        xunwen,
        shishi,
        zhengju,
        jianyi,
        shuoli,
    },
    computed: {
    },
    watch:{
        $route: {
            handler: function(route) {
                if(route.path == '/baxq'){
                    this.ajId = route.query.ajId
                    this.dwId = route.query.dwId
                    this.dwFlag = route.query.dwFlag
                    this.ajFlag = route.query.ajFlag
                    this.isNew = route.query.isNew
                    this.xgType = route.query.xgType
                    this.lsh = route.query.lsh
                    this.getList()
                    // if(route.query.isNew == 1){
                    //     this.$message({
                    //         showClose: true,
                    //         message: '请先选择案件来源，然后进行基础信息比对！',
                    //         type: 'warning'
                    //     });
                    // }else
                    if(route.query.isNew == 2){
                        this.getList2()
                    }
                    
                    // if(route.params.row){
                    //     let row = JSON.parse(decodeURIComponent(route.params.row));
                    //     console.log(row)
                    // }
                    
                }
            },
            immediate: true
        },
    },
    created() {
    },
    async mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.dm = user.dm
        this.xm = user.xm 
        this.cmid = user.c_mid
        this.org = user.jcjg
        this.form2.sjzbr = user.xm
        this.wenhao =  user.wenhao
        this.baseUrl = user.baseUrl
        axios({
            method: 'post',
            url: this.baseUrl+`/xx/selectFaRenType`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                cmid:this.cmid,
            }
        })
        .then(response => {
            console.log(response.data,1194)
            if (response.data && response.data.data) {
                this.jingyingzheOptions = response.data.data || [];
            }
            this.loading = false
        })
        .catch(error => {
            this.loading = false
            this.$message.error('获取数据失败！');
            console.error('There was an error!', error);
        }); 
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getminzu`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.mzOptions = []
                let arr = res.data.data
                arr.forEach(item => {
                    let i = Number(item.id) < 10 ? '0'+item.id : item.id
                    this.mzOptions.push({id: item.id,nation: item.nation,px: item.px,xh:i})
                })
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })  
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getjbks`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.ksOptions = res.data.data || []
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })
        axios({
            method: 'post',
            url: this.baseUrl+`/xx/lawEnforcer`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                cmid:this.cmid
            }
        })
        .then(response => {
            this.userOptions = response.data.data
        })
        .catch(error => {
            this.$message.error('获取监督员数据失败！');
            console.error('There was an error!', error);
        });
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getzhiwu`,
            data:{},
            headers: { 
                "Content-Type": "application/json"
            },
        }).then(res => {
            if(res.data.code == 0 && res.data.data){
                this.zwOptions = res.data.data || []
            }else{
                if(res.data.msg){
                    this.$message.error(res.data.msg)
                }
            }
        }).catch(error => {
            this.$message.error(error);
        })   
        if(this.isNew == 1){
            this.bz = '创建人：'+user.xm+'，联系电话：'+user.sj1
        }else{
            let data3 = await this.$axios.get(`${this.Global._baseUrl2}?act=getdsrjbxx&id=${this.ajId}`)
            if(data3.data){
                this.bz = data3.data[0].data
            }
        }
        axios({
            method: 'post',
            url: this.baseUrl+`/login/getajly`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                pcId:this.pcId,
            }
        })
        .then(response => {
            console.log(response.data);
            this.lyOptions = response.data.data || []
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
        axios({
            method: 'post',
            url: this.baseUrl+`/login/GetTContact`,
            headers: { // 添加请求头
                "Content-Type": "application/json" // 明确声明为 JSON 格式
            },
            data: {
                cmid:this.cmid,
            }
        })
        .then(response => {
            console.log(response.data);
            this.org = response.data.data.c_org || ''
        })
        .catch(error => {
            console.error('There was an error!', error);
        });
        
        this.yearOptions = []
        let year = new Date().getFullYear()
        this.yearOptions.push((year-2)+'')
        this.yearOptions.push((year-1)+'')
        this.yearOptions.push(year+'')
        console.log(this.yearOptions)
    },
    methods: {
        mouseenter(){
            this.isYr = true
        },
        getNo(){
            if(this.form2.gzsno2){
                this.$set(this.form2,'jdsno2',this.form2.gzsno2)
            }
        },
        getNo3(){
            if(this.form2.gzsno3){
                this.$set(this.form2,'jdsno3',this.form2.gzsno3)
            }
        },
        getNo4(){
            if(this.form2.gzsno4){
                this.$set(this.form2,'jdsno4',this.form2.gzsno4)
            }
        },
        getNoa(){
            if(this.form2.jdsno2){
                this.$set(this.form2,'gzsno2',this.form2.jdsno2)
            }
        },
        getNoa3(){
            if(this.form2.jdsno3){
                this.$set(this.form2,'gzsno3',this.form2.jdsno3)
            }
        },
        getNoa4(){
            if(this.form2.jdsno4){
                this.$set(this.form2,'gzsno4',this.form2.jdsno4)
            }
        },
        getList(){
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getajxqym`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    dwmcId: this.dwId,
                    ajflag: 1,
                    dwFlag:this.dwFlag
                }
            })
            .then(response => {
                console.log(response.data);
                this.form1 = response.data.data[0]
                this.dwForm = Object.assign({}, response.data.data[0]);
                if(response.data.data[0].zylbId == '06'){
                    this.xkzText = '医疗机构职业许可证号:'
                }else if(response.data.data[0].zylbId == '04'){
                    this.xkzText = '放射诊疗许可证号:'
                }else{
                    this.xkzText = '卫生许可证号:'
                }
                if(this.isNew == 1){
                    this.$set(this.form2,'reason1',response.data.data.dwmc)
                    this.$set(this.form2,'host_man',this.xm)
                    this.$set(this.form2,'factHost',this.xm)
                    this.text1 = '许可证'
                    this.text2 = '责令停产停业'
                }
            })
            .catch(error => {
                console.error('There was an error!', error);
            });
        },
        async getList2(){
            // this.form2.law = this.row.law
            // this.form2.punish_basis = this.row.punish_basis
            // let dataF = await this.$axios.get(`${this.Global._baseUrl2}?act=getFujiancailiaoCount&pcId=${this.ajId}`)
            // if(dataF.data){

            // }
            
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfxxInfo&id=${this.ajId}`)
            if(data.data){
                let obj = data.data[0]
                for(var i in this.form2){
                    for(var p in obj){
                        if(i == p){
                            this.form2[i] = obj[p]
                        }
                    }
                }
                // if(!this.form2.host_man){
                //     this.form2.host_man = this.row.host_man
                //     this.userOptions.forEach(item => {
                //         if(item.xm == this.row.host_man){
                //             this.form2.hostdh = item.ksdh
                //         }
                //     })
                // }
                if(this.form2.laiyuan && this.form2.laiyuan.indexOf('检验') != -1){
                    this.wsList.push({wsCode:'jsjdwts',wsName:'技术鉴定委托书',wsname: "jishujiandingweituoshu",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: ""})
                }else{
                    let i = this.wsList.findIndex(item => {
                        return item.wsCode == 'jsjdwts'
                    })
                    console.log(i)
                    if(i != -1){
                        this.wsList.splice(i,1)
                    }
                }
                
                this.form2.reason1 = this.form2.reason1 ? this.form2.reason1 : this.form1.dwmc
                if(data.data[0].heyisj_begin && data.data[0].heyisj_end){
                    let dt = data.data[0].heyisj_begin.split(' ')
                    this.form2.heyisj = this.getDate(dt[0],'yyyy-MM-dd')
                    let dt2 = data.data[0].heyisj_end.split(' ')
                    this.form2.heyisj2 = [data.data[0].heyisj_begin,data.data[0].heyisj_end]
                }
                
                this.form2.isdx = data.data[0].dxxkz == '' ? false : true
                this.text1 = this.form2.isdx && this.form2.dxxkz ? this.form2.dxxkz : '许可证'
                this.form2.iszl = data.data[0].zltcty == '' ? false : true
                this.text2 = data.data[0].zltcty == '' ? '责令停产停业' : data.data[0].zltcty
                this.form2.jinggao = data.data[0].jinggao != '警告'?false:true
                this.form2.fakuan = Number(data.data[0].fakuan) > 0 ?true:false
                this.form2.fakuanJine = Number(data.data[0].fakuan) > 0 ? Number(data.data[0].fakuan) : ''
                this.form2.moshou = Number(data.data[0].moshou) > 0 ?true:false
                this.form2.moshouJine = Number(data.data[0].moshou) > 0 ? Number(data.data[0].moshou) : ''
                this.form2.moshou2 = data.data[0].moshouwp ?true:false
                this.form2.txtWupin = data.data[0].moshouwp ? data.data[0].moshouwp : ''
                
                this.form2.jiancha_rq = this.form2.jiancha_rq ? this.getDate(this.form2.jiancha_rq,'yyyy-MM-dd') : ''
                this.form2.jc_rq = this.form2.jc_rq ? this.getDate(this.form2.jc_rq,'yyyy-MM-dd') : ''
                this.form2.lian_rq = this.form2.lian_rq ? this.getDate(this.form2.lian_rq,'yyyy-MM-dd') : ''
                this.form2.shouli_rq = this.form2.shouli_rq ? this.getDate(this.form2.shouli_rq,'yyyy-MM-dd') : ''
                this.form2.aj_shouli_rq = this.form2.aj_shouli_rq ? this.getDate(this.form2.aj_shouli_rq,'yyyy-MM-dd') : ''
                this.form2.jc_jieshoudate = this.form2.jc_jieshoudate ? this.getDate(this.form2.jc_jieshoudate,'yyyy-MM-dd') : ''
                this.form2.jc_gaozhiDate = this.form2.jc_gaozhiDate ? this.getDate(this.form2.jc_gaozhiDate,'yyyy-MM-dd') : ''
                
                if(this.form2.reason22 && this.form2.reason22 != '无'){
                    this.form2.Hreason22 = this.form2.reason2.slice(0,-1) + '等案'
                }else{
                    this.form2.Hreason22 = ''
                }
                console.log(this.form2)
            }
            this.getWss()
            let dataS = await this.$axios.get(`${this.Global._baseUrl2}?act=getSplsh&id=${this.ajId}`)
            if(dataS.data){
                this.form2.spLsh = dataS.data[0].splsh
            }
            let dataX = await this.$axios.get(`${this.Global._baseUrl2}?act=getXcblJlnrShenpi&lshId=${this.ajId}`)
            if(dataX.data){
                
            }
        },
        async getWss(){
            
            this.xcblname = 'xianchangbilu'
            let dataW = await this.$axios.get(`${this.Global._baseUrl2}?act=wenshuchakan&id=${this.ajId}`)
            console.log(1574)
            this.xcblIs = false
            if(dataW.data){
                let arr1 = dataW.data
                let arr2 = []
                arr1.forEach(ele => {
                    if(ele.wsname.indexOf('xianchangbilu') != -1){
                        this.xcblname = ele.wsname
                        if(ele.status == 1){
                            this.xcblIs = true
                        }
                    }
                    arr2.push(ele.wsname)
                })

                // 创建一个空对象，用于根据wsname匹配后的结果
                let idMap = {};
                // 将arr1数组中的对象按id存入idMap
                this.wsList.forEach(item => {
                    if(item.wsname == 'xianchangbilu'){
                        item.wsname = this.xcblname
                    }
                    idMap[item.wsname] = item;
                });
                
                // 遍历arr2数组，根据id更新idMap中对应对象的age属性
                arr1.forEach(item => {
                    if(item.status == 1){
                        if (idMap[item.wsname]) {
                            idMap[item.wsname].blLsh = item.blLsh
                            idMap[item.wsname].count = item.count
                            idMap[item.wsname].lsh = item.lsh
                            idMap[item.wsname].mid = item.mid
                            idMap[item.wsname].status = item.status
                            idMap[item.wsname].wsname = item.wsname
                            idMap[item.wsname].isWc = true
                            idMap[item.wsname].docurl = item.docurl
                        }
                    }else{
                        if (idMap[item.wsname]) {
                            idMap[item.wsname].isWc = false
                        }
                    }
                });
                
                console.log(this.wsList)
                this.$forceUpdate()
            }
        },
        async show(item,val){
            this.iswsBj = val
            if(item.wsname == 'xunwenbilu'){
                this.dialogFormVisible = true
                this.xwblText = ''
                this.blOptions = []
                this.blList = []
                let data = await this.$axios.get(`${this.Global._baseUrl2}?act=wenshuzhuangtaixunwenbilu&id=${this.ajId}`)
                if(data.data){
                    let arr = data.data
                    arr.forEach(ele => {
                        var name = ele.xwbl_nr.indexOf('|')!='-1' ? ele.xwbl_nr.split('|')[3].split('*')[1] : ''
                        this.blOptions.push({name:'询问笔录（'+name+')',blLsh:ele.lsh,mid:item.mid,lsh:item.lsh,docurl:ele.docurl})
                    })
                    this.xwblText = this.blOptions[0].blLsh
                    this.blList.push(this.blOptions[0])
                }
            }else if(item.wsname == 'xianchangzhaopian'){
                this.dialogFormVisible2 = true
                this.xczpText = ''
                this.xczpOptions = []
                this.zpList = []
                let data = await this.$axios.get(`${this.Global._baseUrl2}?act=wenshuzhuangtaixczp&pcId=${this.ajId}`)
                if(data.data){
                    let arr = data.data
                    arr.forEach((ele,index) => {
                        this.xczpOptions.push({name:'现场照片证据'+(index+1)+'',blLsh:ele.lsh,mid:item.mid,lsh:item.lsh,docurl:ele.docurl})
                    })
                    this.xczpText = this.xczpOptions[0].blLsh
                    this.zpList.push(this.xczpOptions[0])
                }
            }else{
                this.show2(item)
            }
        },
        getContent11(){
            console.log(this.form2.content11)
            if(this.form2.content11){
                // 找到逗号的位置
                const index = this.form2.content11.indexOf('，');

                if (index !== -1) {
                    // 使用 substring 方法替换逗号之前的部分为 'abcdef'
                    let str = this.getDate2(this.form2.jiancha_rq) + this.form2.content11.substring(index);

                    console.log(str);  // 输出: "abcdef,12345687"
                    this.$set(this.form2,'content11',str)
                } 
                
            }
        },
        getYlText(){
            this.blList = []
            this.blOptions.forEach(item => {
                if(item.blLsh == this.xwblText){
                    this.blList.push(item)
                }
            })
        },
        getXcText(){
            this.zpList = []
            this.xczpOptions.forEach(item => {
                if(item.blLsh == this.xczpText){
                    this.zpList.push(item)
                }
            })
        },
        show2(item){
            let mid = item.mid
            let lsh = item.lsh
            let wsname = item.wsname.indexOf('xianchangbilu') != -1 ? this.xcblname : item.wsname
            let sjs = new Date().getTime()
            let url = this.$router.resolve({
                path:'/pdf',
                query:{
                    mid:mid,
                    lsh:lsh,
                    wsname:wsname,
                    sjs:sjs
                }
            })
            window.open(url.href,'_blank')
        },
        show3(){
            let mid = this.blList[0].mid
            let lsh = this.blList[0].lsh
            let blLsh = this.blList[0].blLsh
            let sjs = new Date().getTime()
            let url = this.$router.resolve({
                path:'/pdf',
                query:{
                    mid:mid,
                    lsh:lsh,
                    wsname:'xunwenbilu',
                    blLsh:blLsh
                }
            })
            window.open(url.href,'_blank')
        },
        show4(){
            let mid = this.zpList[0].mid
            let lsh = this.zpList[0].lsh
            let blLsh = this.zpList[0].blLsh
            let sjs = new Date().getTime()
            let url = this.$router.resolve({
                path:'/pdf',
                query:{
                    mid:mid,
                    lsh:lsh,
                    wsname:'xianchangzhaopian',
                    blLsh:blLsh
                }
            })
            window.open(url.href,'_blank')
        },
        //获取主办人电话
        getHostdh(){
            let obj =  this.userOptions.filter(item => {
                return item.xm === this.form2.factHost
            })
            this.form2.hostdh = obj[0].ksdh
        },
        //吊销
        getDxnrtk(){
            console.log(this.form2.isdx)
            if(!this.form2.isdx){
                this.text1 = '许可证'
                this.form2.dxxkz = ''
                console.log(this.text1)
                this.$forceUpdate()
            }else{
                this.open6 = true
                this.dxnr = ''
            }
            
        },
        getDxnr(){
            console.log(this.dxnr)
            if(this.dxnr){
                this.text1 =  this.dxnr
                this.form2.dxxkz = this.dxnr
                this.open6 = false
            }else{
                this.$message.error('吊销内容不能为空')
            }
        },
        //责令
        getZlnrtk(){
            console.log(this.form2.iszl)
            if(!this.form2.iszl){
                this.text2 = '责令停产停业'
                this.form2.zltcty = ''
                this.$forceUpdate()
            }else{
                this.open7 = true
                this.zllx = ''
                this.zlnr = ''
            }
            
        },
        getZl(){
            console.log(this.zllx)
        },
        getZlnr(){
            if(this.zllx){
                this.text2 =  this.zllx+this.zlnr
                this.form2.zltcty = this.zllx+this.zlnr
                this.open7 = false
            }else{
                this.$message.error('吊销内容不能为空')
            }
        },
        async changeXcbl(){
            if(this.form2.laiyuan.indexOf('检验') != -1){
                this.wsList.push({wsCode:'jsjdwts',wsName:'技术鉴定委托书',wsname: "jishujiandingweituoshu",isWc:false,blLsh: "",count: "",lsh: "",mid: "",status: ""})
                let rq = this.form2.jiancha_rq ? this.form2.jiancha_rq : 'NaN年NaN月NaN日'
                let rq2 = this.form2.jc_jieshoudate ? this.form2.jc_jieshoudate : 'NaN年NaN月NaN日'
                let text1 = rq +'，'+this.org+'执法人员着装出示执法证对'+this.form1.dwdz+'的'+this.form1.dwmc+'进行卫生监督检测，样品委托检测。'+rq2+'，收到出具的《检测报告》（编号：'+this.form2.jc_jcbh+'），结果显示：'
                this.$set(this.form2,'content11',text1)
                // let rq3 = 'N年N月N日'
                // let text2 = rq3 + '，本机关将检验结果告知当事人。'
                // this.$set(this.form2,'content11',text2)
            }else{
                let i = this.wsList.findIndex(item => {
                    return item.wsCode == 'jsjdwts'
                })
                if(i != -1){
                    this.wsList.splice(i,1)
                }
                
                let rq = this.form2.jiancha_rq ? this.form2.jiancha_rq : 'NaN年NaN月NaN日'
                if(this.form2.laiyuan == '社会投诉举报的'){
                    let text1 = rq +'，'+this.org+'执法人员着装出示执法证（根据投诉举报）对'+this.form1.dwdz+'的'+this.form1.dwmc+'进行检查，发现：'
                    this.$set(this.form2,'content11',text1)
                }else{
                    let text1 = rq +'，'+this.org+'执法人员着装出示执法证对'+this.form1.dwdz+'的'+this.form1.dwmc+'进行检查，发现：'
                    this.$set(this.form2,'content11',text1)
                }
            }
            this.open2 = true
            this.queryParams.dwmc = this.form1.dwmc
            this.xcblList = []
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXcblByMobile&c_mid=${this.cmid}&dwmc=${escape(this.form1.dwmc)}&dwmc2=&mid=${this.form1.mid}&type=shouji`)
            if(data.data){
                this.xcblList = data.data
            }
        },
        queding(){
            console.log(this.bjRow)
            console.log(this.isXcbl)
            this.$set(this.form2,'bl_lsh','')
            if(this.bjRow.lsh){
                this.isXcbl = false
                this.$confirm('点击确定后，所选内容将暂存！', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.open2 = false
                    console.log(this.bjRow)
                    this.$set(this.form2,'jiancha_rq',this.bjRow.bl_date)
                    let text1 = this.bjRow.bl_date +'，'+this.org+'执法人员着装出示执法证对'+this.form1.dwdz+'的'+this.bjRow.dwmc+'进行检查，发现：'
                    this.$set(this.form2,'content11',text1)
                    this.$set(this.form2,'content12',this.bjRow.bl_nr)
                    this.isShowxcbl = true
                    this.$set(this.form2,'bl_lsh',this.bjRow.lsh)
                    this.save(1)
                    this.open2 = false
                }).catch(() => {
                    // this.$message({
                    //     type: 'info',
                    //     message: '已取消删除'
                    // });          
                });
                
            }else{
                if(!this.isXcbl){
                    this.$message.error('请选择现场笔录信息!')
                }else{
                    this.save(1)
                    this.open2 = false
                }
            }
        },
        renew(e){
            this.$forceUpdate()
        },
        getNm(e){
            console.log(e)
            // e = e.replace(/[^\d.]/g, '')
            if (isNaN(e) || e <= 0) {
                e = '';
            } else {
                e = Number(e);
            }
          this.$forceUpdate()
        },
        getIsXcbl(){
            if(this.isXcbl){
                this.xcblList.forEach(item => {
                    item.checked = false
                })
                this.bjRow = {}
            }
        },
        handleSelect(row,index){
            console.log(row)
            this.xcblList.forEach((item,i) => {
                if(i == index){
                    item.checked = true
                }else{
                    item.checked = false
                }
            })
            this.bjRow = row
            this.isXcbl = false
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleAdd(){},
        async handleQuery(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getXcblByMobile&c_mid=${this.cmid}&dwmc=${escape(this.queryParams.dwmc)}&dwmc2=&mid=${this.form1.mid}&type=shouji`)
            if(data.data){
                this.xcblList = data.data
            }
        },
        getCf(){
            console.log(this.cfCheck)
        },
        getBack(){
            let that = this
            this.$confirm("您是否确定当前页面数据已保存吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(() => {
                that.$emit('handleBack',1)
            })
        },
        async getTb(){
            this.tbText = '数据同步中...'
            //同步
            this.tbLoading = true
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=setjbxxtb&c_mid=${this.cmid}&dwmc=${escape(this.form1.dwmc)}&type=1`)
            if(data.data){
                
                console.log(data.data)
                if(data.data[0].errcode == -1){
                    this.tbLoading = false
                    this.$message.error(data.data[0].errMessage)
                }else if(data.data[0].errcode == 0){
                    this.getList()
                    this.tbLoading = false
                    this.$message({
                        message: data.data[0].errMessage,
                        type: 'success'
                    });
                    // this.$forceUpdate()
                    
                }else{
                    this.tbLoading = false
                }
                // else{
                //     this.form1 = data.data[0]
                //     this.dwForm = Object.assign({}, data.data[0]);
                // }
            }
        },
        async getTb2(){
            //同步
            if(!this.form1.zzdm){
                this.$message.error('统一社会信用代码为空，无法同步案件信息！')
                return false
            }
            // let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getJgdxpunishCaseCode&pcid=${this.ajId}`)
            // if(data.data){
            //     console.log(data.data)
            //     this.tbCode = data.data
            // }else{
            //     this.tbCode = 0
            // }
            this.openTb = true
        },
        //选择同步类型
        async tbType(val){
            this.tbtype = val
            this.tbText = '加载中...'
            this.tbLoading = true
            this.loading8 = true
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=setjbxxtb&c_mid=${this.cmid}&zzdm=${escape(this.form1.zzdm)}&dwmc=${escape(this.form1.dwmc)}&dwmc_id=${this.dwId}&code=0&isClose=${val}&typeOne=0&type=3`)
            this.sxxList = []
            this.tbCode = ''
            if(data.data){
                this.tbLoading = false
                if(data.data[0].valdata == '0'){
                    this.$alert('未查询到省系统有此单位！', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {
                            this.openTb = false
                        }
                    });
                }else{
                    this.openTb2 = true
                    console.log(data.data,data.data[0],data.data[0].valdata[0])
                    console.log(data.data[0].valdata[0].datas[0])
                    if(data.data[0].valdata[0].datas[0]){
                        let arr = data.data[0].valdata[0].datas
                        arr.forEach((item,i) => {
                            //item.checked = false
                            this.$set(item, 'checked', false) // 这里，给对象添加属性，用$set方法。
                        })
                        this.sxxList = arr
                    }
                    console.log(this.sxxList)
                }
                this.loading8 = false
            }else{
                this.loading8 = false
                this.tbLoading = false
                this.$alert('未查询到省系统有此单位！', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        this.openTb = false
                    }
                });
            }
        },
        //选择同步案件信息
        handleSelectTb(row,index){
            console.log(row,index)
            this.tbRow = {}
            this.tbCode = row.id
            this.sxxList.forEach((item,i) => {
                console.log(row.checked)
                if(i == index){
                    // if(this.sxxList[index].checked){
                    //     this.$set(item, 'checked', false)
                    // }else{
                        this.$set(item, 'checked', true)
                        this.tbRow = item
                    // }
                }else{
                    this.$set(item, 'checked', false)
                }
            })
            console.log(this.sxxList,index)
            this.$forceUpdate()
            
        },
        async quedingTb(){
            if(!this.tbCode){
                this.$message.error('请先选择同步案件信息!')
                return false;
            }
            this.tbText = '数据同步时间较长，请耐心等待！'
            this.tbLoading = true
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=setjbxxtb&c_mid=${this.cmid}&zzdm=${escape(this.form1.zzdm)}&dwmc=${escape(this.form1.dwmc)}&dwmc_id=${this.dwId}&code=${this.tbRow.punishCaseCode}&isClose=${this.tbtype}&typeOne=1&pcid=${this.ajId}&type=3`)
            if(data.data){
                console.log(data.data)
                this.openTb = false
                this.openTb2 = false
                if(data.data[0].errcode == -1){
                    this.tbLoading = false
                    this.$message.error(data.data[0].errMessage)
                }else if(data.data[0].errcode == 0){
                    this.getList2()
                    this.tbLoading = false
                    this.$message({
                        message: data.data[0].errMessage,
                        type: 'success'
                    });
                }else{
                    this.tbLoading = false
                }
            }
        },
        async showEdit(item){
            if(this.isNew == 1){
                this.$message.error('未暂存不能制作文书！')
            }else{
                if(item.wsCode == 'sxspzjjds' || item.wsCode == 'sxspzjcljds' || item.wsCode == 'zdjttl' || item.wsCode == 'zdfzsh'){
                    console.log(this.xcblIs)
                    if(!this.xcblIs){
                        this.$message.error('请先生成现场笔录！') 
                        return false
                    }
                }
            
                this.falv = ''
                this.anyou = ''
                if(item.wsCode == 'cfajml' || item.wsCode == 'zjxxdjbcjds'){
                    this.width = '1200px'
                }else if(item.wsCode == 'yjyzz'){
                    this.width = '700px'
                }else{
                    this.width = '1000px'
                }
                if(item.wsCode == 'xwbl'){
                    let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getIsGsp&pcId=${this.ajId}`)
                    if(data.data == 0){
                        this.$alert('此单位没有悬挂公示牌，请悉知！', '', {
                            confirmButtonText: '确定',
                            callback: action => {
                                // this.$message({
                                // type: 'info',
                                // message: ``
                                // });
                            }
                        }); 
                    }
                }
                if(item.wsCode == 'zdfzsh' || item.wsCode == 'zdjttl'){
                    this.falv = this.form2.law + this.form2.punish_basis
                    this.anyou = this.form2.reason1 + this.form2.reason2
                    this.cbyj = this.form2.content6
                }
                this.code = item.wsCode
                this.title = item.wsName
                this.open = true
                console.log(item)
            }
        },
        handleBack(){
            console.log(1610)
            this.open = false
            this.getWss()
            this.$forceUpdate()
        },
        closeDialog(){
            this.open = false
            this.getWss()
            this.$forceUpdate()
        },
        getFalv(text,val){
            this.title3 = text
            this.open3 = true
            this.leixing = val
        },
        
        getAnyou(text,val){
            this.title4 = text
            this.open4 = true
            this.leixing2 = val
        },
        getHbAnyou(){
            console.log(this.form2.reason2,this.form2.reason22)
            this.$set(this.form2,'Hreason22','')
            axios({
                method: 'post',
                url: this.baseUrl+`/login/hebinganyou`,
                data:{
                    anyou1:this.form2.reason2,
                    anyou2:this.form2.reason22
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                if(res.data.code == 0 && res.data.msg){
                    this.$set(this.form2,'Hreason22',res.data.msg)
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.$message.error(error);
            })
        },
        delectAnyou(index){
            this.form2.domains.splice(index,1)
        },
        getBacl(){
            this.open5 = true
            this.baly = ''
        },
        //并案理由提交
        balyTj(){
            if(this.baly){
                console.log(this.baly)
            }else{
                this.$message.error('请输入并案理由！')
            }
        },
        //自定义笔录
        async getBlzdy(){
            this.open9 = true
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getxcMb`)
            console.log(data)
            this.zfmbList = []
            if(data.data){
                this.zfmbList = data.data
            }
        },
        getActive(index){
          if(this.isActive == index){
            this.isActive = '-1'
          }else{
            this.isActive = index
          }
        },
        getXunwennr(itema,i){
          this.isActive2 = i
          if(this.blnr.indexOf(itema.mc) != '-1'){
            this.$message.error('不能重复添加')
          }else{
            if(itema.mc.indexOf('<br/>') != -1){
              itema.mc = itema.mc.replace(/<br\s*\/?>/gi, '\n');
            }
            if(this.blnr){
              let zf = this.blnr.substr(this.blnr.length - 1,1)
              let nr = zf != '\n' ? '\n' +  itema.mc : itema.mc
              this.blnr =  this.blnr + nr
            }else{
              this.blnr = itema.mc
            }
          }
        },
        //并案理由提交
        zdyblTj(){
            if(this.blnr){
                console.log(this.blnr)
                this.open9 = false
                this.$set(this.form2,'content12',this.blnr)
                this.save(1)
            }else{
                this.$message.error('请输入笔录内容！')
            }
        },
        //复制笔录
        getFuzhi(text){
            console.log(text)
            // var e = text;
            // e.select();
            // document.execCommand("Copy");
            let msg = text+''
            let that = this
            this.$copyText(msg).then(function (e){
                console.log(e)
                that.$message.success('复制成功')
            })
        },
        //法律弹窗返回内容
        handleBackFalv(data,val){
            if(val == 1){
                this.form2.law = data
                if(data){
                    this.save(1)
                }
            }else{
                this.form2.punish_basis = data
                if(data){
                    this.save(1)
                }
            }

            this.open3 = false
        },
        closeFalv(data){
            this.open3 = false
        },
        //增加从案由
        addAy(){
            this.isCay = true
        },
        addAnyou(){
            this.isAy = this.form2.domains.length > 0 ? this.form2.domains[this.form2.domains.length - 1].key+1 : this.isAy + 1
            console.log(this.isAy)
            this.form2.domains.push({value:'',key:this.isAy})
            console.log(this.form2.domains)
        },
        //案由弹窗返回内容
        handleBackAnyou(data,val){
            if(val == 1){
                if(this.form2.reason22 && this.form2.reason22 == data){
                    this.$message.error('案由禁止重复，请修改!')
                }else{
                    this.form2.reason2 = data
                    this.open4 = false
                }
            }else{
                if(this.form2.reason2 && this.form2.reason2 == data){
                    this.$message.error('案由禁止重复，请修改!')
                }else{
                    this.form2.reason22 = data
                    this.open4 = false
                }
            }
        },
        closeAnyou(data){
            this.open4 = false
        },
        //询问笔录弹窗 
        getXwtk(){
            let n = 0
            this.wsList.forEach(item => {
                if(item.wsname.indexOf('xunwenbilu') != -1){
                    n = item.status
                }
            })
            if(n == 0){
                this.$alert('请先做询问笔录后再做调查询问过程描述', '提示', {
                    confirmButtonText: '确定',
                    callback: action => {
                        // this.$message({
                        // type: 'info',
                        // message: `action: ${ action }`
                        // });
                    }
                });
                return
            }
            this.textXw = this.form2.jiancha_rq
            this.open10 = true
        },
        handleBackXunwen(data){
            this.form2.content2 = data
            this.open10 = false
        },
        closeXunwen(data){
            this.open10 = false
        },
        //违法事实弹窗
        getWfss(){
            this.open11 = true
        },
        handleBackShishi(data){
            this.form2.content3 = data
            if(data){
                this.save(1)
            }
            this.open11 = false
        },
        closeShishi(data){
            this.open11 = false
        },
        //本案取得的证据
        getBazj(){
            this.open12 = true
        },
        handleBackZhengju(data){
            this.form2.content4 = data
            if(data){
                this.save(1)
            }
            this.open12 = false
        },
        closeZhengju(data){
            this.open12 = false
        },
        //处理建议
        getCljy(){
            this.open13 = true
        },
        handleBackJianyi(data){
            this.form2.content5 = data
            if(data){
                this.save(1)
            }
            this.open13 = false
        },
        closeJianyi(data){
            this.open13 = false
        },
        //说理内容
        getSlnr(){
            this.open14 = true
        },
        handleBackShuoli(data){
            this.form2.content6 = data
            if(data){
                this.save(1)
            }
            this.open14 = false
        },
        closeShuoli(data){
            this.open14 = false
        },
        //省数据同步
        async provinceData(){
            if(this.form1.zzdm){
                let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getJgdxDataSync&dwmc=${escape(this.form1.dwmc)}&mid=${this.dwId}&type=0&code=0&creditCode=${this.form1.zzdm}&isClose=0`)
                if(data.data){
                    let valdata = data.data[0].valdata
                    if(data.data[0].outs == '0'){
                        this.$message.error('未查询到省系统有此单位！')
                        this.open8 = true
                    }else if(data.data[0].outs == '99'){
                        this.$message.error('程序异常！请重新点击一次！')
                    }
                    if(valdata != '0'){
                        let object = data.data[0].valdata[0].datas[0]
                    }
                }else{
                    this.$message.error('程序异常！请重新点击一次！')
                }
            }else{
                this.$message.error('统一社会信用代码为空！请补全信息后再次点击基本信息比对！')
            }
        },
        getHysj(t){
            if(this.form2.heyisj2 === null){
                this.form2.heyisj2 = []
                this.$set(this.form2,'heyisj_begin','')
                this.$set(this.form2,'heyisj_end','')
                
            }else{
                this.$set(this.form2,'heyisj_begin',this.form2.heyisj2[0])
                this.$set(this.form2,'heyisj_end',this.form2.heyisj2[1])
            }
            this.$forceUpdate()
        },
        //暂存
        async save(val){
            console.log(val)
            if(!this.form2.jiancha_rq){
                this.$message.error('检查日期不能为空!')
                return
            }else{
                let date = this.getDate(this.form2.jiancha_rq,'yyyy-MM-dd')
                if(!this.form2.shouli_rq){
                    this.$set(this.form2,'shouli_rq',date)
                }
                if(!this.form2.lian_rq){
                    this.$set(this.form2,'lian_rq',date)
                }
            }
            let ajflag = 0;
            if(this.form2.jinggao && !this.form2.fakuan && !this.form2.moshou && !this.form2.moshou2){
                ajflag = 0;
            }else{
                ajflag = 1;
            }
            // let dwId = '20240617150310826'
            // let lsh = '202401123'
            // let ajId = '2782'
            // this.$router.push({name:'/baxq',
            //     query:{
            //         isNew:2,
            //         ajflag:ajflag,
            //         dwId:dwId,
            //         lsh:lsh,
            //         ajId:ajId,
            //         dwFlag:'',
            //     }
            // })
            for(var i in this.form2){
                if(this.form2[i] == null || this.form2[i] == 'null' || this.form2[i] == undefined || this.form2[i] == 'undefined'){
                    this.form2[i] = ''
                }
            }
            console.log(this.form2)
            let id = this.isNew == 1 ? '' : this.ajId
            axios({
                method: 'post',
                url: `${this.Global._baseUrl2}`,
                data: {
                    act: "saveZfxx",
                    type:  escape(val == 1 ? '暂存' : '保存'),
                    id: id,
                    c_mid:`${this.cmid}`,
                    xm: escape(this.xm),
                    dm: this.dm,
                    dw_flag:  `${this.dwFlag}`,
                    ajflag: ajflag,
                    spLsh:  `${this.form2.spLsh}`, 
                    bl_lsh:  `${this.form2.bl_lsh}`,  
                    dwmc_id: `${this.dwId}`, 
                    jiancha_rq: `${this.getDate(this.form2.jiancha_rq,'yyyy-MM-dd')}`,  
                    jc_rq:  `${this.getDate(this.form2.jc_rq,'yyyy-MM-dd')}`,  
                    laiyuan: `${escape(this.form2.laiyuan)}`,  
                    lian_rq: `${this.getDate(this.form2.lian_rq,'yyyy-MM-dd')}`,  
                    shouli_rq: `${this.getDate(this.form2.shouli_rq,'yyyy-MM-dd')}`,  
                    aj_shouli_rq: `${this.getDate(this.form2.aj_shouli_rq,'yyyy-MM-dd')}`,  
                    heyisj: this.form2.heyisj ? `${this.getDate(this.form2.heyisj,'yyyy-MM-dd')}`:'',  
                    heyisj_begin: this.form2.heyisj_begin ? `${this.getDate(this.form2.heyisj_begin,'yyyy-MM-dd hh:mm:ss')}`:'',  
                    heyisj_end: this.form2.heyisj_end ? `${this.getDate(this.form2.heyisj_end,'yyyy-MM-dd hh:mm:ss')}`:'',  
                    jinggao:  this.form2.jinggao ? true : false,  
                    fakuan:  (this.form2.fakuan > 0 || Number(this.form2.fakuanJine) > 0) ? true : false,  
                    fakuanJine: `${Number(this.form2.fakuanJine)}`,  
                    moshou: `${this.form2.moshou}`,  
                    moshouJine: `${Number(this.form2.moshouJine)}`,  
                    moshou2: this.form2.moshou2 ? true : false,  
                    txtWupin: Number(this.form2.txtWupin) > 0 ? Number(this.form2.txtWupin) : 0,  
                    law: `${escape(this.form2.law)}`, 
                    punish_basis: `${escape(this.form2.punish_basis)}`,
                    jingbanKs: `${escape(this.form2.jingbanks)}`,
                    host_man: `${escape(this.form2.host_man)}`,
                    hostdh: `${this.form2.hostdh}`,
                    factHost: `${this.form2.factHost}`,
                    xiebanren: `${escape(this.form2.xiebanren)}`,
                    join_man: `${escape(this.form2.join_man)}`,
                    reason1: `${escape(this.form2.reason1)}`,
                    reason2: `${escape(this.form2.reason2)}`,
                    reason22: `${escape(this.form2.reason22)}`,
                    lianWenhao:  `${this.form2.lianWenhao}`,
                    gzsNo2: `${this.form2.gzsno2}`,
                    gzsNo3:  `${this.form2.gzsno3}`,
                    gzsNo4:  `${this.form2.gzsno4}`,
                    jdsNo2:  `${this.form2.jdsno2}`,
                    jdsNo3:  `${this.form2.jdsno3}`,
                    jdsNo4:  `${this.form2.jdsno4}`,
                    content11: `${escape(this.form2.content11)}`,
                    dashuju:  `${escape(this.form2.dashuju)}`,
                    content12:  `${escape(this.form2.content12)}`,
                    content2: `${escape(this.form2.content2)}`,
                    content3: `${escape(this.form2.content3)}`,
                    content4: `${escape(this.form2.content4)}`,
                    content5: `${escape(this.form2.content5)}`,
                    content6: `${escape(this.form2.content6)}`,
                    dwdz: `${escape(this.form1.dwdz)}`,
                    xkzh: `${escape(this.form1.xkzh)}`,
                    fzr: `${escape(this.form1.fzr)}`,
                    xb: `${escape(this.form1.frxb)}`,
                    nation: `${this.form1.nation}`,
                    zw: `${escape(this.form1.frzw)}`,
                    tyshxydm: `${this.form1.zzdm}`, 
                    sfzh: `${this.form1.sfzh}`,
                    sj1: `${this.form1.sj1}`,
                    jingyingzhe: `${escape(this.form1.jingyingzhe)}`,
                    jingyingzheXm: `${escape(this.form1.jingyingzhexm)}`,
                    dwdz2: `${escape(this.form2.dwdz2)}`,
                    xkzh2: `${escape(this.form2.xkzh2)}`,
                    fzr2: `${escape(this.form2.fzr2)}`,
                    xb2: `${escape(this.form2.xb2)}`,
                    nation2: `${escape(this.form2.nation2)}`,
                    zw2: `${escape(this.form2.zw2)}`,
                    tyshxydm2: `${escape(this.form2.tyshxydm2)}`,
                    sfzh2: `${escape(this.form2.sfzh2)}`,
                    sj12: `${escape(this.form2.sj12)}`,
                    ts_shijian:  `${this.form2.ts_shijian}`,
                    ts_nr:  `${this.form2.ts_nr}`,
                    jc_company: `${this.form2.jc_company}`,
                    jc_jcbh:  `${this.form2.jc_jcbh}`,
                    jc_jieshouDate:  `${this.getDate(this.form2.jc_jieshoudate,'yyyy-MM-dd')}`,
                    jc_gaozhiDate: `${this.getDate(this.form2.jc_gaozhiDate,'yyyy-MM-dd')}`,
                    content112:  `${escape(this.form2.content112)}`,
                    content113: `${escape(this.form2.content113)}`, 
                    sjssj: this.form2.sjssj == 'yes' ? 'yes' : 'no',
                    gjssj: this.form2.gjssj == 'yes' ? 'yes' : 'no',
                    isYbjc: this.form2.isybjc == 'yes' ? 'yes' : 'no',
                    isTsjb: this.form2.istsjb == 'yes' ? 'yes' : 'no',
                    dxxkz: `${this.form2.dxxkz}`,
                    zltcty: `${this.form2.zltcty}`,
                    xwbl_splsh: `${this.form2.xwbl_splsh}`,
                    zyclid: `${this.form2.zyclid}`,
                    buyuChufa: this.form2.buyuChufa ? 1 : 0,
                    ajly_hidden: this.isXcbl ? 1 : 0,
                    strpunishCaseCode:  `${this.form2.strpunishCaseCode}`,
                },
                transformRequest: [function (data) {
                    data = qs.stringify(data);
                    return data;
                }],
                headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
            }).then(res => {
                if(this.isNew == 1){
                        if(res.data[0] && res.data[0].errcode == 0){
                            this.$message({
                                message: '暂存成功',
                                type: 'success'
                            });
                            let dwId = res.data[0].data[0].mid
                            let lsh = res.data[0].data[0].lsh
                            let ajId = res.data[0].data[0].id
                            let ajflag = 1;
                            this.$router.push({name:'/baxq',
                                query:{
                                    isNew:2,
                                    ajflag:ajflag,
                                    dwId:dwId,
                                    lsh:lsh,
                                    ajId:ajId,
                                    dwFlag:'',
                                    xgType:1
                                }
                            })
                    //         setTimeout(()=>{
                    // },1000)
                        }
                    }else{
                        if(res.status == 200){
                            this.$message({
                                message: '暂存成功',
                                type: 'success'
                            });
                        }else{
                            this.$message({
                                message: res.data,
                                type: 'error'
                            });
                        }
                    }
                
            }).catch(res => {
                this.$message({
                    message: '保存失败，请重新填写',
                    type: 'error'
                });
            })
        },
        handleSubmit(){
            this.$confirm('点击保存后不能在修改案件信息，请谨慎操作！', '确认信息', {
                distinguishCancelAndClose: true,
                confirmButtonText: '保存',
                cancelButtonText: '放弃修改'
            })
            .then(() => {
                this.bcType = 2
                //本案取得的证据不能为空!违法事实不能为空!请确认卫生监督意见书，当事人是否签字或电子送达！案件来源不能为空!职务不能为空!
                this.save(2)
            })
            .catch(action => {
                this.$message({
                type: 'info',
                message: action === 'cancel'
                    ? '放弃保存并离开页面'
                    : '停留在当前页面'
                })
            });
        },
        getSJ(){
            console.log(this.form2.lian_rq)
        },
        async bianjiWord(item,num){
            this.iswsBj = num
            console.log(item.docurl)
            if(item.wsname == 'xunwenbilu'){
                this.dialogFormVisible = true
                this.xwblText = ''
                this.blOptions = []
                this.blList = []
                let data = await this.$axios.get(`${this.Global._baseUrl2}?act=wenshuzhuangtaixunwenbilu&id=${this.ajId}`)
                if(data.data){
                    let arr = data.data
                    arr.forEach(ele => {
                        var name = ele.xwbl_nr.indexOf('|')!='-1' ? ele.xwbl_nr.split('|')[3].split('*')[1] : ''
                        this.blOptions.push({name:'询问笔录（'+name+')',blLsh:ele.lsh,mid:item.mid,lsh:item.lsh,docurl:ele.docurl})
                    })
                    this.xwblText = this.blOptions[0].blLsh
                    this.blList.push(this.blOptions[0])
                    console.log(this.blList)
                }
            }else if(item.wsname == 'xianchangzhaopian'){
                this.dialogFormVisible2 = true
                this.xczpText = ''
                this.xczpOptions = []
                this.zpList = []
                let data = await this.$axios.get(`${this.Global._baseUrl2}?act=wenshuzhuangtaixczp&pcId=${this.ajId}`)
                if(data.data){
                    let arr = data.data
                    arr.forEach((ele,index) => {
                        this.xczpOptions.push({name:'现场照片证据'+(index+1)+'',blLsh:ele.lsh,mid:item.mid,lsh:item.lsh,docurl:ele.docurl})
                    })
                    this.xczpText = this.xczpOptions[0].blLsh
                    this.zpList.push(this.xczpOptions[0])
                }
            }else{
                this.edit2(item.docurl)
            }
        },
        edit2(url){
            console.log(url) 
            POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
        },
        edit3(){
            let url = this.blList[0].docurl
            this.edit2(url)
        },
        edit4(){
            let url = this.zpList[0].docurl
            this.edit2(url)
        },
        async wordEdit(item){
            this.dqWord = {}
            console.log(item.docurl)
            if(item.wsname == 'xunwenbilu'){
                this.dialogFormVisible = true
                this.xwblText = ''
                this.blOptions = []
                this.blList = []
                let data = await this.$axios.get(`${this.Global._baseUrl2}?act=wenshuzhuangtaixunwenbilu&id=${this.ajId}`)
                if(data.data){
                    let arr = data.data
                    arr.forEach(ele => {
                        var name = ele.xwbl_nr.indexOf('|')!='-1' ? ele.xwbl_nr.split('|')[3].split('*')[1] : ''
                        this.blOptions.push({name:'询问笔录（'+name+')',blLsh:ele.lsh,mid:item.mid,lsh:item.lsh,docurl:ele.docurl})
                    })
                    this.xwblText = this.blOptions[0].blLsh
                    this.blList.push(this.blOptions[0])
                    console.log(this.blList)
                }
            }else if(item.wsname == 'xianchangzhaopian'){
                this.dialogFormVisible2 = true
                this.xczpText = ''
                this.xczpOptions = []
                this.zpList = []
                let data = await this.$axios.get(`${this.Global._baseUrl2}?act=wenshuzhuangtaixczp&pcId=${this.ajId}`)
                if(data.data){
                    let arr = data.data
                    arr.forEach((ele,index) => {
                        this.xczpOptions.push({name:'现场照片证据'+(index+1)+'',blLsh:ele.lsh,mid:item.mid,lsh:item.lsh,docurl:ele.docurl})
                    })
                    this.xczpText = this.xczpOptions[0].blLsh
                    this.zpList.push(this.xczpOptions[0])
                }
            }else{
                this.dqWord = item
                this.titleWord = item.wsName
                this.dialogWordVisible = true
            }
        },
        editWord(){
            if(this.dqWord.docurl){
                let url = this.dqWord.docurl
                console.log(url)
                POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
            }else{
                this.$message.error('当前word文档地址不存在，请联系管理员！')
            }
        },
        showWord(){
            this.show2(this.dqWord)
        },
        async resetWord(){
            console.log((this.dqWord))
            this.loadingWord = true
            //重新生成文书
            // let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.dqWord.mid}&lsh=${this.dqWord.lsh}&filecode=${this.dqWord.wsname}&DaLsh=`)
            let wsname = this.dqWord.wsname+'.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.dqWord.mid}&lsh=${this.dqWord.lsh}&filecode=${wsname}&DaLsh=`)
            console.log(data)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
        async resetWord3(){
            console.log(this.blList)
            this.loadingWord = true
            //重新生成文书
            let mid = this.blList[0].mid
            let lsh = this.blList[0].lsh
            let blLsh = this.blList[0].blLsh
            let wsname = 'xunwenbilu'+blLsh+'.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${mid}&lsh=${lsh}&filecode=${wsname}&DaLsh=`)
            console.log(data)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
        async resetWord4(){
            console.log(this.zpList)
            this.loadingWord = true
            //重新生成文书
            let mid = this.zpList[0].mid
            let lsh = this.zpList[0].lsh
            let blLsh = this.zpList[0].blLsh
            let wsname = 'xianchangzhaopian.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${mid}&lsh=${lsh}&filecode=${wsname}&DaLsh=${blLsh}`)
            console.log(data)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
        delectReason22(){
            this.$set(this.form2,'reason22','')
            this.$set(this.form2,'Hreason22','')
            this.isCay = false
        }
    }
}
</script>


<style scoped>
.box-cont >>> .search .el-input__inner{ border-radius: 20px;}
.box-cont >>> .el-input.is-disabled .el-input__inner { color: #333;}
.box-cont ul li{padding: 0px 10px 0 15px; margin-top: 10px; width: calc(100% - 27px);height: 54px; line-height: 54px;font-size: 16px;color: #333333; background: #FFFFFF;border-radius: 2px;border: 1px solid #DEDEDE;cursor: pointer;}
.box-cont ul li.active{ color: #0C80E8;}
.box-cont ul li span{ float: left;width: calc(100% - 50px);overflow: hidden; white-space: nowrap;text-overflow: ellipsis;}
.box-cont ul li i{color: #0C80E8; float: right; line-height: 58px; font-size: 18px;}
.liebiao >>> .el-button{border:none;padding: 0;    line-height: 54px;
    font-size: 16px;background: none;width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;text-align: left;}
.content >>>    .el-loading-spinner{
  font-size: 100px;
}
.loading{ width: 100vw; height: 100vh; background: rgba(255,255,255,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 100px;color: #1890ff;opacity: 1; margin-top: 30vh;}
.loading p{   font-size: 20px; color: #333; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px;}
</style>
